import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import "../result/result.css";
import printJS from 'print-js'; // If using npm
import AlertMessage from "../../AlertMessage";

function CbseHighSchoolResult() {
  const [academicYear, setAcademicYear] = useState('');
  const [classValue, setClassValue] = useState('');
  const [selectedExamName, setSelectedExamName] = useState('');
  const [studentData, setStudentData] = useState([]);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [marksData, setMarksData] = useState({});
  const [classes, setClasses] = useState([]);
  const [selectedStudentResults, setSelectedStudentResults] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [schoolName, setSchoolName] = useState('');
  const [schoolLogo, setSchoolLogo] = useState('');
  const [division, setDivision] = useState("");
  const [divisions, setDivisions] = useState([]);
  const [divisionSubjects, setDivisionSubjects] = useState({}); // Store subjects by class and division
  const [dateSelected, setDateSelected] = useState(false);
  const [sansthaName, setSansthaName] = useState('');
  const [taluka, setTaluka] = useState('');
  const [jilha, setJilha] = useState('');
  const [udiseNumberDisplay, setUdiseNumberDisplay] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [email, setEmail] = useState('');
const [previousYearClass, setPreviousYearClass] = useState('');

  const udiseNumber = localStorage.getItem("udiseNumber");
  const [examNames, setExamNames] = useState([
    "Semester First",
    "Semester Second",
    "Combined Result",
  ]);

  const examNameTranslations = {
    "Semester First": "प्रथम सत्र",
    "Semester Second": "द्वितीय सत्र",
    "Combined Result": "द्वितीय सत्र",
  
  };


  // IndexedDB constants
  const DB_NAME = 'SchoolManagementDB';
  const STUDENT_STORE = 'studentData';
  const DB_VERSION = 1;
const SCHOOL_STORE = 'schoolData';


  // Function to open IndexedDB
const openDB = () => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onerror = (event) => {
      console.error("IndexedDB error:", event.target.error);
      reject(event.target.error);
    };

    request.onsuccess = (event) => {
      const db = event.target.result;
      resolve(db);
    };

    request.onupgradeneeded = (event) => {
      const db = event.target.result;

      // Create object stores if they don't exist
      if (!db.objectStoreNames.contains(STUDENT_STORE)) {
        db.createObjectStore(STUDENT_STORE, { keyPath: "id" });
      }
      
      // Add SCHOOL_STORE if it doesn't exist
      if (!db.objectStoreNames.contains(SCHOOL_STORE)) {
        db.createObjectStore(SCHOOL_STORE, { keyPath: "udiseNumber" });
      }
    };
  });
};


  const fetchDivisionsForClass = async (classValue) => {
    try {
      const db = await openDB();
      const transaction = db.transaction(STUDENT_STORE, "readonly");
      const store = transaction.objectStore(STUDENT_STORE);
      const request = store.getAll(); // Fetch all students

      request.onsuccess = (event) => {
        const students = event.target.result;
        const divisionsForClass = new Set();

        students.forEach((student) => {
          if (student.currentClass === classValue) {
            divisionsForClass.add(student.division);
          }
        });

        setDivisions(Array.from(divisionsForClass)); // Update divisions state
      };

      request.onerror = (event) => {
        console.error("Error fetching divisions from IndexedDB:", event.target.error);
      };
    } catch (error) {
      console.error("Error opening IndexedDB:", error);
    }
  };

  // Function to fetch student data from IndexedDB
  const fetchStudentData = async (dbParam = null) => {
      const db = dbParam || await openDB(); // Use provided db or open new one
    return new Promise((resolve, reject) => {
      const transaction = db.transaction(STUDENT_STORE, "readonly");
      const store = transaction.objectStore(STUDENT_STORE);
      const request = store.getAll();

      request.onsuccess = (event) => {
        const students = event.target.result;
        setStudentData(students);


        const classesAndDivisions = {};
        students.forEach((student) => {
          if (student && student.currentClass) {
            if (!classesAndDivisions[student.currentClass]) {
              classesAndDivisions[student.currentClass] = {};
            }

            const division = student.division || "";
            if (!classesAndDivisions[student.currentClass][division]) {
              classesAndDivisions[student.currentClass][division] = [];
            }

            // Use the ID as the serial number equivalent
            classesAndDivisions[student.currentClass][division].push(student.id);
          }
        });

        // Extract class, division, and srNo from key
        const updatedStudents = students.map(student => {
          const keyParts = student.id.split("-"); // Split by "-"
          const className = keyParts[0]; // First part is class
          const division = keyParts[1]; // Second part is division
          const srNo = keyParts[keyParts.length - 1]; // Last part is srNo
          return { ...student, className, division, srNo };
        });

        setClasses(Object.keys(classesAndDivisions));
        setStudentData(updatedStudents); // Store updated students
        resolve(updatedStudents);
      };

      request.onerror = (event) => {
        console.error("Error fetching student data from IndexedDB:", event.target.error);
        reject(event.target.error);
      };
    });
  };


  // Load student data and marks from IndexedDB
  useEffect(() => {
    const loadData = async () => {
      try {
        const db = await openDB();
        await fetchStudentData(db);
      } catch (error) {
        console.error("Error loading data from IndexedDB:", error);
      }
    };

    loadData();
  }, []);

  // Fetch marks data from IndexedDB when exam name changes
  useEffect(() => {
    if (selectedExamName && classValue && academicYear) {
      const fetchMarks = async () => {
        try {
          const db = await openDB();
          const selectedStudents = studentData.filter(
            (student) => student.currentClass === classValue
          );
          setSelectedStudents(selectedStudents);
          const marksDataPromises = selectedStudents.map(async (student) => {
            const studentMarks = await fetchMarksData(db, student.srNo, academicYear, selectedExamName);
            return { srNo: student.srNo, marks: studentMarks };
          });

          const marksDataArray = await Promise.all(marksDataPromises);
          const marksData = marksDataArray.reduce((acc, { srNo, marks }) => {
            acc[srNo] = marks;
            return acc;
          }, {});

          setMarksData(marksData);
        } catch (error) {
          console.error('Error fetching marks data:', error);
        }
      };

      fetchMarks();
    }
  }, [selectedExamName, classValue, academicYear]);



  useEffect(() => {
    const fetchDefaultSettings = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/defaultSettings.json`);
        if (response.ok) {
          const data = await response.json();

          if (data) {
            setAcademicYear(data.defaultYear || "");
          }
        } else {
          console.error("Failed to fetch default settings.");
        }
      } catch (error) {
        console.error("Error fetching default settings:", error);
      }
    };

    fetchDefaultSettings();
  }, [udiseNumber]);
  const [language, setLanguage] = useState(localStorage.getItem('language') || 'English');

  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  useEffect(() => {
    if (alertMessage) {
      setShowAlert(true);
      const timeoutId = setTimeout(() => {
        setShowAlert(false);
        setAlertMessage("");
      }, 3000);
      return () => clearTimeout(timeoutId);
    } 
  }, [alertMessage]);


  const [subjectSequence, setSubjectSequence] = useState([]); // New state for subject sequence
 // Update your useEffect hook
useEffect(() => {
  if (academicYear && (classValue || previousYearClass) && division) {
    fetchSubjectSequence();
  }
}, [academicYear, classValue, previousYearClass, division]);

// Modified fetchSubjectSequence to use previous year class when available
const fetchSubjectSequence = async () => {
  try {
    const classToUse = previousYearClass || classValue;
    const response = await fetch(
      `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/subjectSequence/icse/${academicYear}/${classToUse}/${division}.json`
    );
    
    if (!response.ok) {
      throw new Error('Failed to fetch subject sequence');
    }
    
    const data = await response.json();
    const orderedSubjects = Object.keys(data)
      .sort((a, b) => parseInt(a) - parseInt(b))
      .map((key) => data[key]);
    
    setSubjectSequence(orderedSubjects);
  } catch (error) {
    console.error('Error fetching subject sequence:', error);
    setSubjectSequence([]);
  }
};


  useEffect(() => {
    const storedLanguage = localStorage.getItem('language') || 'English';
    setLanguage(storedLanguage);
  }, []);


 const fetchSchoolName = async () => {
  try {
    const db = await openDB();
    const transaction = db.transaction(SCHOOL_STORE, 'readonly');
    const store = transaction.objectStore(SCHOOL_STORE);
    
    // Get the school data using the udiseNumber as key
    const request = store.get(udiseNumber);

    request.onsuccess = (event) => {
      const schoolData = event.target.result;
      if (schoolData) {
        // Set school name and logo from IndexedDB
        setSchoolName(schoolData.schoolName || '-');
        setSchoolLogo(schoolData.schoolLogo || '');
        setSansthaName(schoolData.sansthaName || '');
      setMobileNumber(schoolData.mobileNumber || '');
            setUdiseNumberDisplay(schoolData.udiseNumber || udiseNumber || '-');
      setJilha(schoolData.jilha || '');
      setTaluka(schoolData.taluka || '')
      setEmail(schoolData.email || '-');
        // Update language if available in school data
        if (schoolData.language) {
          setLanguage(schoolData.language);
          localStorage.setItem('language', schoolData.language);
        }
      } else {
        console.log('No school data found in IndexedDB');
        // Fallback to empty values if no data found
        setSchoolName('-');
        setSchoolLogo('');
      }
    };

    request.onerror = (event) => {
      console.error('Error fetching school data from IndexedDB:', event.target.error);
      // Fallback to empty values on error
      setSchoolName('-');
      setSchoolLogo('');
    };
  } catch (error) {
    console.error('Error accessing IndexedDB:', error);
    // Fallback to empty values on error
    setSchoolName('-');
    setSchoolLogo('');
  }
};
useEffect(() => {
    fetchSchoolName();
       fetchStudentData();
  }, [udiseNumber]); // Add udiseNumber as dependency


  const handleAcademicYearChange = (e) => setAcademicYear(e.target.value);


  const handleClassChange = async (e) => {
    const selectedClass = e.target.value;
    setClassValue(selectedClass); // Update the class value
    setDivision(""); // Reset division when class changes

    if (selectedClass) {
      await fetchDivisionsForClass(selectedClass);
    }
  };

  const handleExamNameChange = (e) => {
    setSelectedExamName(e.target.value);
  };

  const filteredExamNames = examNames.filter((examName) => examName === "Semester Second");

  const fetchSubjectsForClassAndDivision = async (classValue, division) => {
    try {
      if (!classValue || !division || !academicYear) {
        console.error("Class, division, or academic year not set");
        return;
      }

      const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/subjectSequence/icse/${academicYear}/${classValue}/${division}.json`;
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Failed to fetch subjects for class ${classValue} and division ${division}`);
      }
      const subjectsData = await response.json();
      if (subjectsData) {
        const validSubjects = Object.entries(subjectsData)
          .filter(([_, value]) => value !== null && value !== undefined)
          .map(([_, subject]) => subject);

        setDivisionSubjects(prev => ({
          ...prev,
          [classValue]: {
            ...prev[classValue],
            [division]: validSubjects,
          },
        }));
      } else {
        setDivisionSubjects(prev => ({
          ...prev,
          [classValue]: {
            ...prev[classValue],
            [division]: [],
          },
        }));
      }
    } catch (error) {
      console.error(`Error fetching subjects: ${error}`);
    }
  };

  // Fetch subjects when class or division changes
  useEffect(() => {
    if (classValue && division) {
      fetchSubjectsForClassAndDivision(classValue, division);
    }
  }, [classValue, division, academicYear]);


const fetchMarksData = async (db, srNo, academicYear, examName) => {
  return new Promise((resolve, reject) => {
    const transaction = db.transaction(STUDENT_STORE, "readonly");
    const store = transaction.objectStore(STUDENT_STORE);
    const request = store.get(srNo);

    request.onsuccess = (event) => {
      const student = event.target.result;
      if (student && student.cbseResult && student.cbseResult[academicYear] && student.cbseResult[academicYear][examName]) {
        const marks = student.cbseResult[academicYear][examName];
        
        // Create a new object with processed subject names
        const processedMarks = {};
        for (const [subject, data] of Object.entries(marks)) {
          // Replace underscores with dots in subject names
          const processedSubject = subject.replace(/_/g, '.');
          processedMarks[processedSubject] = data;
        }
        
        resolve(processedMarks);
      } else {
        resolve({}); // Return an empty object if marks data is not found
      }
    };

    request.onerror = (event) => {
      console.error("Error fetching marks data from IndexedDB:", event.target.error);
      reject(event.target.error);
    };
  });
};


const viewResult = async (srNo) => {
  try {
    console.log("Clicked SR No:", srNo);
    console.log("Selected Students:", selectedStudents);

    // Ensure selectedStudents has data
    if (!selectedStudents || selectedStudents.length === 0) {
      setAlertMessage("No student data available. Please load students first.");
      return;
    }

    // Extract only the srNo (last part after the last "-")
    const extractedSrNo = srNo.split("-").pop();
    console.log("Extracted SR No:", extractedSrNo);

    // Find student by extracted SR No
    const student = selectedStudents.find((student) => student.srNo === extractedSrNo);
    console.log("Matched Student:", student);

    if (!student) {
      setAlertMessage(`Student with SR No: ${extractedSrNo} not found!`);
      return;
    }

    // Open IndexedDB
    const db = await openDB();
    console.log("Database Opened:", db);

    // Fetch marks from IndexedDB
    const [
      firstSemesterData,
      secondSemesterData,
      unitTestIData,
      unitTestIIData,
      unitTestIIIData,
      unitTestIVData,
      unitTestVData,
      unitTestVIData,
    ] = await Promise.all([
      fetchMarksData(db, srNo, academicYear, "Semester First"),
      fetchMarksData(db, srNo, academicYear, "Semester Second"),
      fetchMarksData(db, srNo, academicYear, "Unit Test I"),
      fetchMarksData(db, srNo, academicYear, "Unit Test II"),
      fetchMarksData(db, srNo, academicYear, "Unit Test III"),
      fetchMarksData(db, srNo, academicYear, "Unit Test IV"),
      fetchMarksData(db, srNo, academicYear, "Unit Test V"),
      fetchMarksData(db, srNo, academicYear, "Unit Test VI"),
    ]);

    console.log("Fetched Marks Data:");
    console.log("First Semester:", firstSemesterData);
    console.log("Second Semester:", secondSemesterData);
    console.log("Unit Test I:", unitTestIData);
    console.log("Unit Test II:", unitTestIIData);
    console.log("Unit Test III:", unitTestIIIData);
    console.log("Unit Test IV:", unitTestIVData);

    // Check if all fetched data is empty
    const isEmpty = (obj) => !obj || Object.keys(obj).length === 0;

    if (
      isEmpty(firstSemesterData) &&
      isEmpty(secondSemesterData) &&
      isEmpty(unitTestIData) &&
      isEmpty(unitTestIIData) &&
      isEmpty(unitTestIIIData) &&
      isEmpty(unitTestIVData) &&
      isEmpty(unitTestVData) &&
      isEmpty(unitTestVIData)
    ) {
      setAlertMessage("No marks data found. Please enter marks to view the result.");
      return;
    }

    const resultsWithTotal = {};

    // Combine subjects across all datasets
    const allSubjects = new Set([
      ...Object.keys(firstSemesterData || {}),
      ...Object.keys(secondSemesterData || {}),
      ...Object.keys(unitTestIData || {}),
      ...Object.keys(unitTestIIData || {}),
      ...Object.keys(unitTestIIIData || {}),
      ...Object.keys(unitTestIVData || {}),
      ...Object.keys(unitTestVData || {}),
      ...Object.keys(unitTestVIData || {}),
    ]);

    console.log("secondSemesterData----------", secondSemesterData);

    // Aggregate marks for each subject
    allSubjects.forEach((subject) => {
      if (subject) {
        resultsWithTotal[subject] = {
          obtainMarks: secondSemesterData?.[subject]?.obtainMarks || 0,
          outOf: secondSemesterData?.[subject]?.outOf || 0,
          firstSemesterObtainMarks: firstSemesterData?.[subject]?.obtainMarks || 0,
          firstSemesterOutOf: firstSemesterData?.[subject]?.outOf || 0,
          secondSemesterObtainMarks: secondSemesterData?.[subject]?.obtainMarks || 0,
          secondSemesterOutOf: secondSemesterData?.[subject]?.outOf || 0,
          unitTestIObtainMarks: unitTestIData?.[subject]?.obtainMarks || 0,
          unitTestIOutOf: unitTestIData?.[subject]?.outOf || 0,
          unitTestIIObtainMarks: unitTestIIData?.[subject]?.obtainMarks || 0,
          unitTestIIOutOf: unitTestIIData?.[subject]?.outOf || 0,
          unitTestIIIObtainMarks: unitTestIIIData?.[subject]?.obtainMarks || 0,
          unitTestIIIOutOf: unitTestIIIData?.[subject]?.outOf || 0,
          unitTestIVObtainMarks: unitTestIVData?.[subject]?.obtainMarks || 0,
          unitTestIVOutOf: unitTestIVData?.[subject]?.outOf || 0,
          unitTestVObtainMarks: unitTestVData?.[subject]?.obtainMarks || 0,
          unitTestVOutOf: unitTestVData?.[subject]?.outOf || 0,
          unitTestVIObtainMarks: unitTestVIData?.[subject]?.obtainMarks || 0,
          unitTestVIOutOf: unitTestVIData?.[subject]?.outOf || 0,
          
          // Add grade information
          firstSemesterGrade: firstSemesterData?.[subject]?.grade,
          secondSemesterGrade: secondSemesterData?.[subject]?.grade,
          unitTestIGrade: unitTestIData?.[subject]?.grade,
          unitTestIIGrade: unitTestIIData?.[subject]?.grade,
          unitTestIIIGrade: unitTestIIIData?.[subject]?.grade,
          unitTestIVGrade: unitTestIVData?.[subject]?.grade,
          unitTestVGrade: unitTestVData?.[subject]?.grade,
          unitTestVIGrade: unitTestVIData?.[subject]?.grade,
          
          // Add subtype information to identify grade vs marks
          firstSemesterSubtype: firstSemesterData?.[subject]?.subtype,
          secondSemesterSubtype: secondSemesterData?.[subject]?.subtype,
          unitTestISubtype: unitTestIData?.[subject]?.subtype,
          unitTestIISubtype: unitTestIIData?.[subject]?.subtype,
          unitTestIIISubtype: unitTestIIIData?.[subject]?.subtype,
          unitTestIVSubtype: unitTestIVData?.[subject]?.subtype,
          unitTestVSubtype: unitTestVData?.[subject]?.subtype,
          unitTestVISubtype: unitTestVIData?.[subject]?.subtype,
        };
      }
    });

    console.log("Final Results Data:", resultsWithTotal);

    // Set state for selected student results
    setSelectedStudentResults({
      studentName: student.stdName,
      results: resultsWithTotal,
      stdMother: student.stdMother,
      stdFather: student.stdFather,
      stdSurname: student.stdSurname,
      dob: student.dob,
      division: student.division,
      motherTounge: student.motherTounge,
      studentId: student.studentId,
      gender: student.gender,
      registerNo: student.registerNo,
      rollNo: student.rollNo,
      stdPhoto: student.stdPhoto,
      currentClass: student.currentClass,
      srNostd: student.serialNo,
      // Add the remarks
      firstSemesterRemark: firstSemesterData?.remark || '',
      secondSemesterRemark: secondSemesterData?.remark || '',
    });

    console.log("Opening Modal...");
    setShowModal(true);
  } catch (error) {
    console.error("Error fetching student results:", error);
    setAlertMessage("An error occurred. Please try again.");
  }
};




  const calculateGradeEnglish = (total) => {
    if (total >= 90) return 'A+';
    if (total >= 80) return 'A';
    if (total >= 70) return 'B+';
    if (total >= 60) return 'B';
    if (total >= 50) return 'C+';
    if (total >= 40) return 'C';
    if (total >= 30) return 'D+';
    if (total >= 20) return 'D';
    return 'Fail';
  };

  const calculateGradeMarathi = (total) => {
    if (total >= 90) return 'अ-1';
    if (total >= 80) return 'अ-2';
    if (total >= 70) return 'ब-1';
    if (total >= 60) return 'ब-2';
    if (total >= 50) return 'क-1';
    if (total >= 40) return 'क-2';
    if (total >= 30) return 'ड-1';
    if (total >= 20) return 'ड-2';
    return 'नापास';
  };

  // Function to calculate grade based on the current language
  const calculateGrade = (total) => {
    return language === 'English' ? calculateGradeEnglish(total) : calculateGradeMarathi(total);
  };

  const handleCloseModal = () => setShowModal(false);

  const handlePrint = async () => {
    try {
      const printContent = document.querySelector('.modal-body'); // Select the modal body content
      const attendanceInput = document.getElementById('attendance');


      if (!printContent) {
        console.error('Print content not found');
        return;
      }

      // Clone the print content and apply styles
      const clone = printContent.cloneNode(true);

      // Remove print button from the cloned content - Make sure this selector matches your print button
      clone.querySelectorAll('.no-print, button, .print-btn, [type="button"]').forEach(element => {
        element.remove();
      });

      // Find the attendance input in the clone and replace it with a static text element
      const clonedAttendanceInput = clone.querySelector('#attendance');
      if (clonedAttendanceInput) {
        // Get the current value from the original input
        const attendanceValue = attendanceInput ? attendanceInput.value : '';

        // Create a replacement span with the attendance value
        const attendanceSpan = document.createElement('span');
        attendanceSpan.textContent = attendanceValue || 'Not specified';
        attendanceSpan.style.borderBottom = '1px solid #000';
        attendanceSpan.style.padding = '0 5px';
        const attendanceContainer = clonedAttendanceInput.parentNode;
        attendanceContainer.replaceChild(attendanceSpan, clonedAttendanceInput);
      }




      // Apply scaling with increased size
      clone.style.padding = "10px"; // Add padding to balance scaling
      clone.style.margin = "0 auto"; // Center the content
      clone.style.transform = "scale(1.2)"; // Increase scale size
      clone.style.transformOrigin = "top center"; // Scale from the center-top
      clone.style.width = "fit-content"; // Ensure it doesn't overflow horizontally

      // Reset unnecessary styles to avoid blank space
      clone.querySelectorAll('p').forEach(p => {
        p.style.margin = "0";
        p.style.padding = "0";
        p.style.lineHeight = "1.4";
      });

      // Create a temporary container for the clone
      const printContainer = document.createElement("div");
      printContainer.style.margin = "0 auto"; // Center container
      printContainer.appendChild(clone);

      // Use printJS to print the content
      printJS({
        printable: printContainer.innerHTML,
        type: 'raw-html',
        style: `
                @media print {
                    body { margin: 0; padding: 0; }
                    p { margin: 0; padding: 0; line-height: 1.4; }

 .table {
  width: 100%;
  border-collapse: collapse;
}

.table th, .table td {
  border: 1px solid #000;
  padding: 8px;
  text-align: center;
  font-size: 12px
}

.table th {
  background-color: #f2f2f2;
  font-weight: bold;
    font-size: 12px
}

.table thead th {
  vertical-align: middle;
}

.table tbody td {
  vertical-align: middle;
}

.text-center {
  text-align: center;
}


                    .school-info {
                        display: flex;
                        align-items: center;
                        margin-bottom: 20px;
                    }

                    .school-info img {
                        width: 100px;
                        height: 100px;
                        object-fit: cover;
                        margin-right: 20px;
                    }

                    .grad{
  position: absolute; /* add this */
  bottom: 25px; /* add this */
  left: 20px; /* add this */
  width: 90%; /* add this */
}


                  .parent-area{
                      margin-top:10px !important;
                      padding-top:8px  !important;
                  }

                    @page {
                        margin: 0; /* Remove default page margins */
                    }
                }
            `
      });
    } catch (error) {
      console.error('Error in handlePrint:', error);
    }
  };


  const handlePrit = async () => {
    try {
      const printContent = document.querySelector('.modal-body'); // Select the modal body content
      const attendanceInput = document.getElementById('attendance');
      const remarkInput = document.getElementById('remark-input');
      const dateInput = document.getElementById('date'); // Get the date input element

      if (!printContent) {
        console.error('Print content not found');
        return;
      }

      // Clone the print content and apply styles
      const clone = printContent.cloneNode(true);

      // Remove print button from the cloned content - Make sure this selector matches your print button
      clone.querySelectorAll('.no-print, button, .print-btn, [type="button"]').forEach(element => {
        element.remove();
      });


      const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      };
  

      // Find the attendance input in the clone and replace it with a static text element
      const clonedAttendanceInput = clone.querySelector('#attendance');
      if (clonedAttendanceInput) {
        const attendanceValue = attendanceInput ? attendanceInput.value : '';

        // Create a replacement span with the attendance value
        const attendanceSpan = document.createElement('span');
        attendanceSpan.textContent = attendanceValue || 'Not specified';
        attendanceSpan.style.borderBottom = '1px solid transparent';
        attendanceSpan.style.padding = '0 5px';


        // Replace the input with the span
        const attendanceContainer = clonedAttendanceInput.parentNode;
        attendanceContainer.replaceChild(attendanceSpan, clonedAttendanceInput);
      }


      // Replace Remark input with span
      const clonedRemarkInput = clone.querySelector('#remark-input');
      if (clonedRemarkInput) {
        const remarkValue = remarkInput?.value || 'Not specified';
        const span = document.createElement('span');
        span.textContent = remarkValue;
        span.style.padding = '0 5px';

        clonedRemarkInput.parentNode.replaceChild(span, clonedRemarkInput);
      }

      // Find the date input in the clone and replace it with a static text element
      const clonedDateInput = clone.querySelector('#date');
      if (clonedDateInput) {
        const dateValue = dateInput ? dateInput.value : '';

        // Create a replacement span with the date value
        const dateSpan = document.createElement('span');
        dateSpan.textContent = formatDate(dateValue) || 'Not specified';
        dateSpan.style.padding = '0 5px';

        // Replace the input with the span
        const dateContainer = clonedDateInput.parentNode;
        dateContainer.replaceChild(dateSpan, clonedDateInput);
      }

      // Apply scaling with reduced size
      clone.style.padding = "15px";
      clone.style.margin = "0 auto";
      clone.style.transform = "scale(1.1)";
      clone.style.transformOrigin = "top center";
      clone.style.width = "fit-content";

      // Reset unnecessary styles
      clone.querySelectorAll('p').forEach(p => {
        p.style.margin = "0";
        p.style.padding = "0";
        p.style.lineHeight = "1.3";
        p.style.fontSize = "12px";
      });

      // Create a temporary container for the clone
      const printContainer = document.createElement("div");
      printContainer.style.margin = "0 auto";
      printContainer.appendChild(clone);

      // Use printJS to print the content
      printJS({
        printable: printContainer.innerHTML,
        type: 'raw-html',
        style: `
    @media print {
        .no-print, button, .print-btn, input[type="button"], input[type="submit"] { 
            display: none !important; 
            visibility: hidden !important;
        } 
        
        body { margin: 0; padding: 0; font-size: 14px; }
        p { margin: 0; padding: 0; line-height: 1.3; font-size: 14px; }
        
        .table {
            width: 100%;
            border-collapse: collapse;
        }

        .table th, .table td {
            border: 1px solid #000;
            padding: 5px;
            text-align: center;
            font-size: 12px;
        }

        .table th {
            background-color: #f2f2f2;
            font-weight: bold;
            font-size: 12px;
        }

        .table thead th,
        .table tbody td {
            vertical-align: middle;
        }

        .text-center {
            text-align: center;
        }

        .school-info {
            display: flex;
            align-items: center;
            margin-bottom: 10px;
        }

        .school-info img {
            width: 80px;
            height: 80px;
            object-fit: cover;
            margin-right: 15px;
        }

        .grad {
            position: absolute;
            bottom: 20px;
            left: 15px;
            width: 90%;
        }
.parent-area{
                      margin-top:10px !important;
                      padding-top:8px  !important;
                  }
        @page {
            margin: 0;
        }
    }
`

      });
    } catch (error) {
      console.error('Error in handlePrint:', error);
    }
  };


  

  const storeStudentADRInIndexedDB = async (studentId, academicYear, examName, attendance, date, remark) => {
    try {
      const db = await openDB();
      const transaction = db.transaction(STUDENT_STORE, "readwrite");
      const store = transaction.objectStore(STUDENT_STORE);
      
      // Get the current student data using the correct key format (studentId)
      const request = store.get(studentId);
      
      request.onsuccess = (event) => {
        let studentData = event.target.result;
        
        if (!studentData) {
          console.error("Student not found with ID:", studentId);
          return;
        }
        
        // Initialize the stdADR structure if it doesn't exist
        if (!studentData.stdADR) {
          studentData.stdADR = {};
        }
        
        if (!studentData.stdADR[academicYear]) {
          studentData.stdADR[academicYear] = {};
        }
        
        // Update the ADR data
        studentData.stdADR[academicYear][examName] = {
          attendance,
          date,
          remark
        };
        
        // Save the updated student data
        const updateRequest = store.put(studentData);
        
        updateRequest.onsuccess = () => {
          console.log("ADR data saved to IndexedDB successfully");
        };
        
        updateRequest.onerror = (error) => {
          console.error("Error saving ADR data to IndexedDB:", error);
        };
      };
      
      request.onerror = (event) => {
        console.error("Error retrieving student data for ADR update:", event.target.error);
      };
    } catch (error) {
      console.error("Error saving ADR data to IndexedDB:", error);
    }
  };
  
  // Fixed Firebase storage function
  const storeStudentADRInFirebase = async (udiseNumber, srNo, academicYear, examName, attendance, date, remark) => {
    try {
      // Make sure srNo is properly formatted (just the number)
      const formattedSrNo = srNo.toString();
      
      // Construct the Firebase URL
      const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData/${srNo}/stdADR/${academicYear}/${examName}.json`;
      
      const response = await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attendance,
          date,
          remark
        })
      });
      
      if (!response.ok) {
        throw new Error(`Failed to save ADR data to Firebase: ${response.statusText}`);
      }
      
      console.log("ADR data saved to Firebase successfully");
    } catch (error) {
      console.error("Error saving ADR data to Firebase:", error);
    }
  };
  
  // Updated function to handle saving attendance, date, and remark
  const handleSaveADR = () => {
    if (!selectedStudentResults || !academicYear || !selectedExamName) {
      console.error("Missing required data to save ADR");
      return;
    }
    
    console.log("Saving ADR data for:", selectedStudentResults);
    
    // Store in IndexedDB - using the correct student ID format 
    // (which appears to be in the format "Class IX-A-211")
    storeStudentADRInIndexedDB(
      selectedStudentResults.studentId || `${selectedStudentResults.currentClass}-${selectedStudentResults.division}-${selectedStudentResults.srNostd}`,
      academicYear,
      selectedExamName,
      attendance,
      selectedDate,
      remarkText
    );
    
    // Store in Firebase - using the numerical srNo
    storeStudentADRInFirebase(
      udiseNumber, 
      selectedStudentResults.srNostd,
      academicYear,
      selectedExamName,
      attendance,
      selectedDate,
      remarkText
    );
    
    // Provide feedback to the user
    setAlertMessage("Attendance, date and remark saved successfully!");
  };

// Add this to your component
const [attendance, setAttendance] = useState("");
const [remarkText, setRemarkText] = useState("");
const [selectedDate, setSelectedDate] = useState("");



// Function to fetch student ADR data from Firebase
const fetchStudentADRFromFirebase = async (udiseNumber, srNo, academicYear, examName) => {
  try {
    // Make sure srNo is properly formatted (just the number)
    const formattedSrNo = srNo.toString();
    
    // Construct the Firebase URL
    const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData/${formattedSrNo}/stdADR/${academicYear}/${examName}.json`;
    console.log("url",url);
    
    const response = await fetch(url);
    
    if (!response.ok) {
      throw new Error(`Failed to fetch ADR data from Firebase: ${response.statusText}`);
    }
    
    const data = await response.json();
    console.log("ADR data fetched from Firebase:", data);
    
    // If data is null, return null to indicate no data found
    if (!data) {
      return null;
    }
    
    return {
      attendance: data.attendance || "",
      date: data.date || "",
      remark: data.remark || ""
    };
  } catch (error) {
    console.error("Error fetching ADR data from Firebase:", error);
    return null;
  }
};

useEffect(() => {
  if (studentData && studentData.length > 0) {
    // Rest of your code here...
  }
}, [studentData]);


// Add this to your useEffect that runs when selectedStudentResults changes
useEffect(() => {
  if (selectedStudentResults && academicYear && selectedExamName) {
    // Fetch existing ADR data
    console.log("selectedStudentResults",selectedStudentResults);
    
    const fetchADRData = async () => {
      const adrData = await fetchStudentADRFromFirebase(
        udiseNumber,
        selectedStudentResults.srNostd,
        academicYear,
        selectedExamName
      );
      
      if (adrData) {
        setAttendance(adrData.attendance || "");
        setSelectedDate(adrData.date || "");
        setRemarkText(adrData.remark || "");
      } else {
        // Reset fields if no data found
        setAttendance("");
        setSelectedDate("");
        setRemarkText("");
      }
    };
    
    fetchADRData();
  }
}, [selectedStudentResults, academicYear, selectedExamName]);




// Add this function to your component





  return (
    <div>
      <AlertMessage message={alertMessage} show={showAlert} />

      <div className=' main-content-of-page'>
        <h3 style={{ color: 'rgb(3, 54, 94)', textAlign: 'center' }}> {language === "English" ? " Exam Result " : "परीक्षेचा निकाल"}</h3>
        <table className="table table-striped table-bordered">
          <tbody>
            <tr>
              <th style={{ width: 'calc(100% / 7)' }}> {language === "English" ? "Year " : "शैक्षणिक वर्ष  "}</th>
              <td>
                <select
                  id="academicYear"
                  defaultValue={academicYear} // Add this prop
                  value={academicYear}
                  onChange={handleAcademicYearChange}
                  className="form-control custom-select"
                >
                  <option >{language === "English" ? "Select Year " : "वर्ष निवडा "}</option>
                  <option value="2023-2024" >2023-2024</option>
                  <option value="2024-2025" selected>2024-2025</option>
                  <option value="2025-2026">2025-2026</option>
                  <option value="2026-2027">2026-2027</option>
                </select>
              </td>
            </tr>
            <tr>
              <th> {language === "English" ? "Class " : "वर्ग"}</th>
              <td>
                <select
                  id="class"
                  value={classValue}
                  onChange={handleClassChange}
                  className="form-control custom-select"
                >
                  <option value="">{language === "English" ? "Select Class " : "वर्ग निवडा"}</option>
                  {classes.map((cls, index) => (
                    <option key={index} value={cls}>
                      {cls}
                    </option>
                  ))}
                </select>
              </td>
            </tr>
            <tr>
              <th>{language === "English" ? "Division " : "तुकडी"}</th>
              <td>
                <select
                  id="division"
                  value={division}
                  onChange={(e) => setDivision(e.target.value)}
                  className="form-control custom-select"
                >
                  <option value="">{language === "English" ? "Select Division " : "तुकडी निवडा"}</option>
                  {divisions.map((div, index) => (
                    <option key={index} value={div}>
                      {div}
                    </option>
                  ))}
                </select>
              </td>
            </tr>
            <tr>
              <th>{language === "English" ? "Exam Name " : "परीक्षा"}</th>
              <td>
                <select
                  id="examName"
                  value={selectedExamName}
                  onChange={handleExamNameChange}
                  className="form-control custom-select"
                >
                  <option value="">{language === "English" ? "Select Exam" : "परीक्षा निवडा"}</option>
                  {examNames.map((examName, index) => (
                    <option key={index} value={examName}>
                      {language === "English" ? examName : examNameTranslations[examName]}
                    </option>
                  ))}
                </select>
              </td>
            </tr>

            {academicYear && academicYear !== "2025-2026" && (
  <tr>
    <th>{language === "English" ? "Previous Year Class" : "मागील वर्षाचा वर्ग"}</th>
    <td>
      <select
        value={previousYearClass}
        onChange={(e) => setPreviousYearClass(e.target.value)}
        className="form-control custom-select"
      >
        <option value="">{language === "English" ? "Select Previous Year Class" : "मागील वर्षाचा वर्ग निवडा"}</option>
        {classes.map((cls, index) => (
          <option key={index} value={cls}>
            {cls}
          </option>
        ))}
      </select>
    </td>
  </tr>
)}

          </tbody>
        </table>




      {selectedStudents.length > 0 && (
  <div className="mt-4">
    <table className="table table-striped table-bordered custom-table">
      <thead>
        <tr>
          <th className="custom-width">
            {language === "English" ? "Roll No " : "हजेरी क्र"}
          </th>
          <th>
            {language === "English" ? "Student's Name " : "विद्यार्थ्याचे नाव"}
          </th>
          <th>
            {language === "English" ? "cbseResult " : "प्रगतीपत्रक"}
          </th>
        </tr>
      </thead>
      <tbody>
        {selectedStudents
          .filter(
            (student) => student.division === division && student.isActive !== false
          ) // ✅ filter division + active students only
          .sort((a, b) => a.rollNo - b.rollNo)
          .map((student) => (
            <tr key={student.srNo}>
              <td>{student.rollNo}</td>
              <td>
                {student.stdName} {student.stdFather} {student.stdSurname}
              </td>
              <td>
                <button
                  className="btn btn-primary"
                  onClick={() => viewResult(student.id)}
                >
                  {language === "English" ? "View cbseResult" : "प्रगति पत्रक"}
                </button>
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  </div>
)}


        <Modal show={showModal} onHide={handleCloseModal} dialogClassName='modal-80w'>
          <Modal.Header closeButton>
            <Modal.Title>{language === "English" ? "Exam Result " : "विद्यार्थ्यांचे निकाल"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>

            {selectedExamName === 'Semester Second' && selectedStudentResults ? (
              
              
              
            <div className="report-card-container" style={{ fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif" }}>
  <div className="report-card" style={{
    width: '615px',
    height: '900px',
    margin: '0 auto',
    padding: '20px',
    border: '3px solid #2c3e50',
    borderRadius: '10px',
    boxShadow: '0 0 20px rgba(0,0,0,0.1)',
    boxSizing: 'border-box',
    overflow: 'hidden',
    background: 'linear-gradient(to bottom, #f9f9f9, #fff)',
    position: 'relative'
  }}>
    
    {/* Header Section */}
    <div className="header" style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '10px',
      position: 'relative',
      zIndex: 1
    }}>

      {schoolLogo && (
        <img
          src={schoolLogo}
          alt="School Logo"
          style={{ 
            width: '80px', 
            height: '80px', 
            objectFit: 'contain',
            border: '2px solid #2c3e50',
            borderRadius: '50%',
            padding: '5px',
            background: 'white'
          }}
        />
      )}
      
       <div style={{ textAlign: 'center', flexGrow: 1 }}>
  <p style={{ 
    margin: '0 0 4px 0', // bottom la thoda space thevla ahe
    color: '#2c3e50',
    textTransform: 'uppercase',
    fontSize: '12px'
  }}>
    {sansthaName}
  </p>
  <h2 style={{ 
    margin: '0', // h2 cha sagla margin remove kela
    color: '#2c3e50',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    fontSize: '22px',
  }}>
    {schoolName}
  </h2>
</div>

      <div
    style={{
      position: 'absolute',
      bottom: '0',
      left: '50%',
      transform: 'translateX(-50%)',
      fontSize: '12px',
      color: 'black',
      whiteSpace: 'nowrap',
      textAlign: 'center',
      width: '100%',
      paddingBottom: '0',
      margin:'-8px'
    }}
  >
    <span>
      {taluka && jilha && (
        <>
          {language === 'English' ? 'Tal: ' : 'तालुका :'} {taluka},{' '}
          {language === 'English' ? 'Dist: ' : 'जिल्हा :'} {jilha},{' '}
        </>
      )}
      {mobileNumber && (
        <>
          {language === 'English' ? 'Mob: ' : 'फोन नं. :'} {mobileNumber},{' '}
        </>
      )}
      {udiseNumber && (
        <>
          {language === 'English' ? 'UDISE: ' : 'UDISE:'} {udiseNumber}{' '}
        </>
      )}
    </span>
  </div>
      
      <div style={{ width: '80px' }}></div> {/* Spacer for alignment */}
    </div>

    {/* Title Section */}
    <div className="title-section" style={{
      background: 'linear-gradient(to right, #3498db, #2c3e50)',
      color: 'white',
      padding: '8px 0',
      borderRadius: '5px',
      marginBottom: '15px',
      position: 'relative',
      zIndex: 1
    }}>
      <h3 style={{ 
        textAlign: 'center', 
        margin: '0',
        fontSize: '18px',
        fontWeight: '600',
        letterSpacing: '1px'
      }}>
        {language === "English" ? "SECOND SEMESTER REPORT CARD" : "विद्यार्थी प्रगती अहवाल"}
      </h3>
      <h4 style={{ 
        textAlign: 'center', 
        margin: '3px 0 0',
        fontSize: '16px',
        fontWeight: '500'
      }}>
        {language === "English" ? `ACADEMIC YEAR ${academicYear}` : `द्वितीय सत्र परीक्षा - ${academicYear}`}
      </h4>
    </div>

    {/* Student Basic Info */}
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '14px' }}>
      <div style={{ flex: '1', textAlign: 'left' }}>
        <label htmlFor="roll-no" style={{ fontSize: '14px' }}>{language === "English" ? "Roll No : " : "हजेरी क्रमांक : "}</label>
        <span>{selectedStudentResults?.rollNo || '-'}</span>
      </div>
      <div style={{ flex: '1', textAlign: 'center' }}>
        <label htmlFor="Register No" style={{ fontSize: '14px' }}>{language === "English" ? "GR No: " : "रजिस्टर क्रमांक : "}</label>
        <span>{selectedStudentResults?.registerNo || '-'}</span>
      </div>
      <div style={{ flex: '1', textAlign: 'right' }}>
        {classValue ?
          <span>{classValue} {selectedStudentResults?.division || '-'} </span>
          :
          <span>
            <label htmlFor="class" style={{ fontSize: '14px' }}>{language === "English" ? "Class : " : "वर्ग : "}</label>
            {selectedStudentResults?.division || '-'}
          </span>
        }
      </div>
    </div>
    <hr style={{
      width: 'calc(100% + 40px)', height: '2px', backgroundColor: 'black', border: 'none', marginLeft: '-20px', marginRight: '-20px', marginTop: '1px'
    }} />
    <div style={{ fontSize: '14px', marginLeft: '30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <div style={{ width: '70%' }}>
        <div>
          <label htmlFor="student-name" style={{ fontSize: '14px' }}>{language === "English" ? "Student's Name : " : "विद्यार्थ्याचे नाव : "}</label>
          <span>{selectedStudentResults?.studentName || '-'} {selectedStudentResults?.stdFather || '-'} {selectedStudentResults?.stdSurname || '-'}</span>
        </div>
        <div>
          <label htmlFor="class" style={{ fontSize: '14px' }}>{language === "English" ? "Mother's Name : " : "आईचे वर्ग : "}</label>
          <span>{selectedStudentResults?.stdMother || '-'} </span>
        </div>
        <div>
          <label htmlFor="class" style={{ fontSize: '14px' }}>{language === "English" ? "Date Of Birth : " : "जन्मतारीख : "}</label>
          <span>
            {selectedStudentResults?.dob ?
              `${new Date(selectedStudentResults.dob).getDate().toString().padStart(2, '0')}/${(new Date(selectedStudentResults.dob).getMonth() + 1).toString().padStart(2, '0')}/${new Date(selectedStudentResults.dob).getFullYear()}`
              : '-'}
          </span>
        </div>
        <div>
          <label htmlFor="exam-roll-no" style={{ fontSize: '14px' }}>{language === "English" ? "Exam : " : "परीक्षा सत्र : "}</label>
          <span>{selectedExamName || '-'}</span>
        </div>
      </div>
      <div style={{ width: '30%' }}>
        {selectedStudentResults?.stdPhoto && (
          <img src={selectedStudentResults?.stdPhoto} style={{ width: '80px', height: '80px' }} />
        )}
      </div>
    </div>

    {/* Results Table */}
    {selectedStudentResults?.results ? (
      <div className="results-table" style={{
        marginBottom: '15px',
        position: 'relative',
        zIndex: 1
      }}>
        <table style={{
          width: '100%',
          borderCollapse: 'collapse',
          fontSize: '12px',
          boxShadow: '0 0 10px rgba(0,0,0,0.05)',
        }}>
          <thead>
            <tr>
              <th rowSpan="2" style={{
                padding: '8px',
                border: '1px solid #ddd',
                textAlign: 'center',
                background: 'linear-gradient(to right, #3498db, #2980b9)',
                color: 'white',
                fontWeight: 'bold'
              }}>
                {language === "English" ? "Subject" : "विषय"}
              </th>

              {["Unit Test IV", "Unit Test V", "Unit Test VI", "Semester II", "Grand Total"].map((title, i) => (
                <th key={i} colSpan="2" style={{
                  padding: '8px',
                  border: '1px solid #ddd',
                  textAlign: 'center',
                  background: 'linear-gradient(to right, #3498db, #2980b9)',
                  color: 'white',
                  fontWeight: 'bold'
                }}>
                  {language === "English" ? title : (
                    title === "Unit Test IV" ? "चौथी चाचणी" :
                    title === "Unit Test V" ? "पाचवी चाचणी" :
                    title === "Unit Test VI" ? "सहावी चाचणी" :
                    title === "Semester II" ? "द्वितीय सत्र" :
                    "एकूण गुण"
                  )}
                </th>
              ))}

              <th rowSpan="2" style={{
                padding: '8px',
                border: '1px solid #ddd',
                textAlign: 'center',
                background: 'linear-gradient(to right, #3498db, #2980b9)',
                color: 'white',
                fontWeight: 'bold'
              }}>
                {language === "English" ? "Grade" : "श्रेणी"}
              </th>
            </tr>

            <tr>
              {Array(5).fill(0).map((_, i) => (
                <React.Fragment key={i}>
                  <th style={{
                    padding: '6px',
                    border: '1px solid #ddd',
                    fontWeight: 'normal',
                    background: 'linear-gradient(to right, #3498db, #2980b9)',
                    color: 'white'
                  }}>
                    {language === "English" ? (i === 4 ? "Total" : "M.M") : (i === 4 ? "गुण" : "पैकी")}
                  </th>
                  <th style={{
                    padding: '6px',
                    border: '1px solid #ddd',
                    fontWeight: 'normal',
                    background: 'linear-gradient(to right, #3498db, #2980b9)',
                    color: 'white'
                  }}>
                    {language === "English" ? (i === 4 ? "%" : "Obt.M") : (i === 4 ? "%" : "गुण")}
                  </th>
                </React.Fragment>
              ))}
            </tr>
          </thead>

          
          
          <tbody>
            {subjectSequence
              .filter((subject) => {
                const grades = selectedStudentResults.results[subject];
                return (
                  grades && (
                    grades.unitTestIVObtainMarks ||
                    grades.unitTestVObtainMarks ||
                    grades.unitTestVIObtainMarks ||
                    grades.secondSemesterObtainMarks ||
                    grades.unitTestIVGrade ||
                    grades.unitTestVGrade ||
                    grades.unitTestVIGrade ||
                    grades.secondSemesterGrade
                  )
                );
              })
              .map((subject, index) => {
                const grades = selectedStudentResults.results[subject];
                
                const displayValue = (obtainMarks, outOf, grade, subtype) => {
                  if (subtype === "Grade" && grade) {
                    return grade;
                  } else if (obtainMarks || obtainMarks === 0) {
                    return obtainMarks;
                  }
                  return "AB";
                };
                
                const displayOutOf = (outOf, subtype) => {
                  if (subtype === "Grade") {
                    return "-";
                  }
                  return outOf || "AB";
                };

                const hasNumericalData = grades.unitTestIVObtainMarks || grades.unitTestVObtainMarks || 
                                        grades.unitTestVIObtainMarks || grades.secondSemesterObtainMarks;
                let totalOutOf = 0;
                let totalObtainMarks = 0;
                let rowPercentage = "-";
                let grade = "-";
                if (hasNumericalData) {
                  totalOutOf = (grades.unitTestIVOutOf || 0) + (grades.unitTestVOutOf || 0) + 
                              (grades.unitTestVIOutOf || 0) + (grades.secondSemesterOutOf || 0);
                  totalObtainMarks = (grades.unitTestIVObtainMarks || 0) + (grades.unitTestVObtainMarks || 0) + 
                                    (grades.unitTestVIObtainMarks || 0) + (grades.secondSemesterObtainMarks || 0);
                  rowPercentage = totalOutOf > 0 ? ((totalObtainMarks / totalOutOf) * 100).toFixed(2) : "-";
                  grade = rowPercentage !== "-" ? calculateGrade(Number(rowPercentage)) : "-";
                }
                return (
                  <tr key={subject} style={{
                    backgroundColor: index % 2 === 0 ? '#f8f9fa' : 'white',
                    borderBottom: '1px solid #e0e0e0'
                  }}>
                    <td style={{
                      padding: '4px',
                      border: '1px solid #ddd',
                      fontWeight: '500',
                      color: '#2c3e50'
                    }}>
                      {subject.length > 20 ? (
                        <>
                          {subject.substring(0, 20)}<br/>{subject.substring(20)}
                        </>
                      ) : (
                        subject
                      )}
                    </td>
                    <td style={{ padding: '4px', border: '1px solid #ddd', textAlign: 'center' }}>
                      {displayOutOf(grades.unitTestIVOutOf, grades.unitTestIVSubtype)}
                    </td>
                    <td style={{ padding: '4px', border: '1px solid #ddd', textAlign: 'center' }}>
                      {displayValue(grades.unitTestIVObtainMarks, grades.unitTestIVOutOf, grades.unitTestIVGrade, grades.unitTestIVSubtype)}
                    </td>
                    <td style={{ padding: '4px', border: '1px solid #ddd', textAlign: 'center' }}>
                      {displayOutOf(grades.unitTestVOutOf, grades.unitTestVSubtype)}
                    </td>
                    <td style={{ padding: '4px', border: '1px solid #ddd', textAlign: 'center' }}>
                      {displayValue(grades.unitTestVObtainMarks, grades.unitTestVOutOf, grades.unitTestVGrade, grades.unitTestVSubtype)}
                    </td>
                    <td style={{ padding: '4px', border: '1px solid #ddd', textAlign: 'center' }}>
                      {displayOutOf(grades.unitTestVIOutOf, grades.unitTestVISubtype)}
                    </td>
                    <td style={{ padding: '4px', border: '1px solid #ddd', textAlign: 'center' }}>
                      {displayValue(grades.unitTestVIObtainMarks, grades.unitTestVIOutOf, grades.unitTestVIGrade, grades.unitTestVISubtype)}
                    </td>
                    <td style={{ padding: '4px', border: '1px solid #ddd', textAlign: 'center' }}>
                      {displayOutOf(grades.secondSemesterOutOf, grades.secondSemesterSubtype)}
                    </td>
                    <td style={{ padding: '4px', border: '1px solid #ddd', textAlign: 'center' }}>
                      {displayValue(grades.secondSemesterObtainMarks, grades.secondSemesterOutOf, grades.secondSemesterGrade, grades.secondSemesterSubtype)}
                    </td>
                    <td style={{ 
                      padding: '4px', 
                      border: '1px solid #ddd', 
                      textAlign: 'center',
                      fontWeight: '600',
                    }}>
                      {hasNumericalData ? `${totalObtainMarks}/${totalOutOf}` : "-"}
                    </td>
                    <td style={{ 
                      padding: '4px', 
                      border: '1px solid #ddd', 
                      textAlign: 'center',
                      fontWeight: '600'
                    }}>
                      {rowPercentage}
                    </td>
                    <td style={{ 
                      padding: '4px', 
                      border: '1px solid #ddd', 
                      textAlign: 'center',
                      fontWeight: '600',
                      color: '#27ae60'
                    }}>
                      {grade}
                    </td>
                  </tr>
                );
              })}
              {/* Totals Row */}
              {selectedStudentResults && selectedStudentResults.results && (
                <tr style={{
                  backgroundColor: '#f1f8e9',
                  fontWeight: 'bold'
                }}>
                  <td style={{ padding: '4px', border: '1px solid #ddd' }}>
                    {language === "English" ? "Total Marks" : "एकूण गुण"}
                  </td>
                  {["unitTestIVOutOf", "unitTestIVObtainMarks", "unitTestVOutOf", "unitTestVObtainMarks", "unitTestVIOutOf", "unitTestVIObtainMarks", "secondSemesterOutOf", "secondSemesterObtainMarks"].map((key, index) => (
                    <td key={index} style={{ padding: '4px', border: '1px solid #ddd', textAlign: 'center' }}>
                      {subjectSequence
                        .filter(subject => {
                          const grades = selectedStudentResults.results[subject] || {};
                          return grades.unitTestIVObtainMarks || grades.unitTestVObtainMarks || grades.unitTestVIObtainMarks || grades.secondSemesterObtainMarks;
                        })
                        .reduce((total, subject) => {
                          const grades = selectedStudentResults.results[subject] || {};
                          return total + (grades[key] || 0);
                        }, 0)}
                    </td>
                  ))}
                  <td style={{ padding: '4px', border: '1px solid #ddd', textAlign: 'center' }}>
                    {subjectSequence
                      .filter(subject => {
                        const grades = selectedStudentResults.results[subject] || {};
                        return grades.unitTestIVObtainMarks || grades.unitTestVObtainMarks || grades.unitTestVIObtainMarks || grades.secondSemesterObtainMarks;
                      })
                      .reduce((total, subject) => {
                        const grades = selectedStudentResults.results[subject] || {};
                        return total + (grades.unitTestIVObtainMarks || 0) + (grades.unitTestVObtainMarks || 0) + (grades.unitTestVIObtainMarks || 0) + (grades.secondSemesterObtainMarks || 0);
                      }, 0)}
                    / 
                    {subjectSequence
                      .filter(subject => {
                        const grades = selectedStudentResults.results[subject] || {};
                        return grades.unitTestIVObtainMarks || grades.unitTestVObtainMarks || grades.unitTestVIObtainMarks || grades.secondSemesterObtainMarks;
                      })
                      .reduce((total, subject) => {
                        const grades = selectedStudentResults.results[subject] || {};
                        return total + (grades.unitTestIVOutOf || 0) + (grades.unitTestVOutOf || 0) + (grades.unitTestVIOutOf || 0) + (grades.secondSemesterOutOf || 0);
                      }, 0)}
                  </td>
                  <td style={{ padding: '4px', border: '1px solid #ddd', textAlign: 'center' }}>
                    {(() => {
                      const filteredSubjects = subjectSequence.filter(subject => {
                        const grades = selectedStudentResults.results[subject] || {};
                        return grades.unitTestIVObtainMarks || grades.unitTestVObtainMarks || grades.unitTestVIObtainMarks || grades.secondSemesterObtainMarks;
                      });
                      const totalMaxMarks = filteredSubjects.reduce((total, subject) => {
                        const grades = selectedStudentResults.results[subject] || {};
                        return total + (grades.unitTestIVOutOf || 0) + (grades.unitTestVOutOf || 0) + (grades.unitTestVIOutOf || 0) + (grades.secondSemesterOutOf || 0);
                      }, 0);
                      const totalObtainedMarks = filteredSubjects.reduce((total, subject) => {
                        const grades = selectedStudentResults.results[subject] || {};
                        return total + (grades.unitTestIVObtainMarks || 0) + (grades.unitTestVObtainMarks || 0) + (grades.unitTestVIObtainMarks || 0) + (grades.secondSemesterObtainMarks || 0);
                      }, 0);
                      return totalMaxMarks > 0 ? ((totalObtainedMarks / totalMaxMarks) * 100).toFixed(2) + '%' : '0%';
                    })()}
                  </td>
                  <td style={{ padding: '4px', border: '1px solid #ddd', textAlign: 'center' }}>
                    {(() => {
                      const filteredSubjects = subjectSequence.filter(subject => {
                        const grades = selectedStudentResults.results[subject] || {};
                        return grades.unitTestIVObtainMarks || grades.unitTestVObtainMarks || grades.unitTestVIObtainMarks || grades.secondSemesterObtainMarks;
                      });
                      const totalMaxMarks = filteredSubjects.reduce((total, subject) => {
                        const grades = selectedStudentResults.results[subject] || {};
                        return total + (grades.unitTestIVOutOf || 0) + (grades.unitTestVOutOf || 0) + (grades.unitTestVIOutOf || 0) + (grades.secondSemesterOutOf || 0);
                      }, 0);
                      const totalObtainedMarks = filteredSubjects.reduce((total, subject) => {
                        const grades = selectedStudentResults.results[subject] || {};
                        return total + (grades.unitTestIVObtainMarks || 0) + (grades.unitTestVObtainMarks || 0) + (grades.unitTestVIObtainMarks || 0) + (grades.secondSemesterObtainMarks || 0);
                      }, 0);
                      const percentage = totalMaxMarks > 0 ? (totalObtainedMarks / totalMaxMarks) * 100 : 0;
                      return language === 'English' ? calculateGradeEnglish(percentage) : calculateGradeMarathi(percentage);
                    })()}
                  </td>
                </tr>
              )}
              {/* Remarks Row */}
              {selectedStudentResults && selectedStudentResults.results && (
                <tr>
                  <td style={{ padding: '4px', border: '1px solid #ddd', fontWeight: 'bold' }}>
                    {language === "English" ? "Remarks" : "शेरा"}
                  </td>
                  <td colSpan="11" style={{ padding: '4px', border: '1px solid #ddd' }}>
                    <input
                      type="text"
                      id="remark-input"
                      placeholder="Enter Remark"
  value={remarkText}
  onChange={(e) => setRemarkText(e.target.value)}
                      style={{
                        border: 'none',
                        borderBottom: '1px solid transparent',
                        outline: 'none',
                        background: 'transparent',
                        fontSize: '12px'
                      }}
                    />
                  </td>
                </tr>
              )}
          </tbody>
        </table>
      </div>
    ) : (
      <div style={{
        padding: '20px',
        textAlign: 'center',
        color: '#7f8c8d',
        fontStyle: 'italic'
      }}>
        {language === "English" ? "No results available." : "कोणतेही प्रगतीपत्रक उपलब्ध नाहीत."}
      </div>
    )}

    {/* Summary Section */}
    <div className="summary" style={{
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: '10px',
      padding: '8px',
      background: '#f5f5f5',
      borderRadius: '5px',
      border: '1px solid #e0e0e0',
      position: 'relative',
      zIndex: 1,
      fontSize: '12px'
    }}>
      <div style={{ flex: 1 }}>
        <div style={{ marginBottom: '10px' }}>
          <span style={{ fontWeight: '600', marginRight: '10px' }}>
            {language === "English" ? "Out Of:" : "एकूण:"}
          </span>
          <span style={{ fontWeight: '600' }}>
            {subjectSequence
              .filter(subject => {
                const grades = selectedStudentResults?.results?.[subject] || {};
                return grades.unitTestIVObtainMarks || grades.unitTestVObtainMarks || grades.unitTestVIObtainMarks || grades.secondSemesterObtainMarks;
              })
              .reduce((total, subject) => {
                const grades = selectedStudentResults?.results?.[subject] || {};
                return total + (grades.unitTestIVOutOf || 0) + (grades.unitTestVOutOf || 0) + (grades.unitTestVIOutOf || 0) + (grades.secondSemesterOutOf || 0);
              }, 0)}
          </span>
        </div>
        
        <div style={{ marginBottom: '10px' }}>
          <span style={{ fontWeight: '600', marginRight: '10px' }}>
            {language === "English" ? "Obtained Marks:" : "प्राप्त गुण:"}
          </span>
          <span style={{ fontWeight: '600' }}>
            {subjectSequence.reduce((total, subject) => {
              const grades = selectedStudentResults?.results?.[subject] || {};
              return (
                total +
                (grades.unitTestIVObtainMarks || 0) +
                (grades.unitTestVObtainMarks || 0) +
                (grades.unitTestVIObtainMarks || 0) +
                (grades.secondSemesterObtainMarks || 0)
              );
            }, 0)}
          </span>
        </div>
        
        <div>
          <span style={{ fontWeight: '600', marginRight: '10px' }}>
            {language === "English" ? "Attendance:" : "उपस्थिती:"}
          </span>
          <input
            type="text"
            id="attendance"
            placeholder={language === "English" ? "Enter attendance" : "उपस्थिती प्रविष्ट करा"}
            value={attendance}
            onChange={(e) => setAttendance(e.target.value)}
            style={{
              border: 'none',
              borderBottom: '1px solid #7f8c8d',
              outline: 'none',
              padding: '5px 0',
              background: 'transparent',
              width: '80px',
              fontWeight: '600'
            }}
          />
        </div>
      </div>
      
      <div style={{ flex: 1, textAlign: 'right' }}>
        <div style={{ marginBottom: '10px' }}>
          <span style={{ fontWeight: '600', marginRight: '10px' }}>
            {language === "English" ? "Percentage:" : "टक्केवारी:"}
          </span>
          <span style={{ fontWeight: '600', color: '#27ae60' }}>
            {(() => {
              const filteredSubjects = subjectSequence.filter(subject => {
                const grades = selectedStudentResults?.results?.[subject] || {};
                return (
                  grades.unitTestIVObtainMarks > 0 ||
                  grades.unitTestVObtainMarks > 0 ||
                  grades.unitTestVIObtainMarks > 0 ||
                  grades.secondSemesterObtainMarks > 0
                );
              });

              const totalMaxMarks = filteredSubjects.reduce((total, subject) => {
                const grades = selectedStudentResults?.results?.[subject] || {};
                return (
                  total +
                  (grades.unitTestIVOutOf || 0) +
                  (grades.unitTestVOutOf || 0) +
                  (grades.unitTestVIOutOf || 0) +
                  (grades.secondSemesterOutOf || 0)
                );
              }, 0);

              const totalObtainedMarks = filteredSubjects.reduce((total, subject) => {
                const grades = selectedStudentResults?.results?.[subject] || {};
                return (
                  total +
                  (grades.unitTestIVObtainMarks || 0) +
                  (grades.unitTestVObtainMarks || 0) +
                  (grades.unitTestVIObtainMarks || 0) +
                  (grades.secondSemesterObtainMarks || 0)
                );
              }, 0);

              return totalMaxMarks > 0
                ? ((totalObtainedMarks / totalMaxMarks) * 100).toFixed(2) + "%"
                : "0%";
            })()}
          </span>
        </div>
        
        <div>
          <span style={{ fontWeight: '600', marginRight: '10px' }}>
            {language === "English" ? "Overall Grade:" : "एकूण श्रेणी:"}
          </span>
          <span style={{ 
            fontWeight: 'bold', 
            color: '#27ae60',
            padding: '3px 10px',
            borderRadius: '3px',
            background: '#e8f5e9'
          }}>
            {(() => {
              const filteredSubjects = subjectSequence.filter(subject => {
                const grades = selectedStudentResults?.results?.[subject] || {};
                return grades.unitTestIVObtainMarks || grades.unitTestVObtainMarks || grades.unitTestVIObtainMarks || grades.secondSemesterObtainMarks;
              });
              const totalMaxMarks = filteredSubjects.reduce((total, subject) => {
                const grades = selectedStudentResults?.results?.[subject] || {};
                return total + (grades.unitTestIVOutOf || 0) + (grades.unitTestVOutOf || 0) + (grades.unitTestVIOutOf || 0) + (grades.secondSemesterOutOf || 0);
              }, 0);
              const totalObtainedMarks = filteredSubjects.reduce((total, subject) => {
                const grades = selectedStudentResults?.results?.[subject] || {};
                return total + (grades.unitTestIVObtainMarks || 0) + (grades.unitTestVObtainMarks || 0) + (grades.unitTestVIObtainMarks || 0) + (grades.secondSemesterObtainMarks || 0);
              }, 0);
              const percentage = totalMaxMarks > 0 ? (totalObtainedMarks / totalMaxMarks) * 100 : 0;
              return language === 'English' ? calculateGradeEnglish(percentage) : calculateGradeMarathi(percentage);
            })()}
          </span>
        </div>
      </div>
    </div>

    {/* Signatures Section */}
    <div className="signatures" style={{
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: '30px',
      paddingTop: '20px',
      position: 'relative',
      zIndex: 1,
    }}>
      <div style={{ textAlign: 'center', width: '30%' }}>
        <div style={{
          height: '1px',
          background: '#7f8c8d',
          marginBottom: '10px',

        }}></div>
        <div style={{ fontWeight: '600' }}>
          {language === "English" ? "Parent's Sign" : "पालकांची सही"}
        </div>
      </div>
      
      <div style={{ textAlign: 'center', width: '30%' }}>
        <div style={{
          height: '1px',
          background: '#7f8c8d',
          marginBottom: '10px'
        }}></div>
        <div style={{ fontWeight: '600' }}>
          {language === "English" ? "Class Teacher Sign" : "वर्गशिक्षक"}
        </div>
      </div>
      
      <div style={{ textAlign: 'center', width: '30%' }}>
        <div style={{
          height: '1px',
          background: '#7f8c8d',
          marginBottom: '10px'
        }}></div>
        <div style={{ fontWeight: '600' }}>
          {language === "English" ? "Principal Sign" : "प्राचार्य"}
        </div>
      </div>
    </div>
  </div>
</div>


            ) : selectedExamName === 'Semester First' && selectedStudentResults ? (


              <div className="report-card-container" style={{ fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif" }}>
  <div className="report-card" style={{
    width: '615px',
    height: '900px',
    margin: '0 auto',
    padding: '20px',
    border: '3px solid #2c3e50',
    borderRadius: '10px',
    boxShadow: '0 0 20px rgba(0,0,0,0.1)',
    boxSizing: 'border-box',
    overflow: 'hidden',
    background: 'linear-gradient(to bottom, #f9f9f9, #fff)',
    position: 'relative'
  }}>
    
    {/* Header Section */}
    <div className="header" style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '10px',
      position: 'relative',
      zIndex: 1
    }}> 
      {schoolLogo && (
        <img
          src={schoolLogo}
          alt="School Logo"
          style={{ 
            width: '80px', 
            height: '80px', 
            objectFit: 'contain',
            border: '2px solid #2c3e50',
            borderRadius: '50%',
            padding: '5px',
            background: 'white'
          }}
        />
      )}
      
      <div style={{ textAlign: 'center', flexGrow: 1 }}>
  <p style={{ 
    margin: '0 0 4px 0', // bottom la thoda space thevla ahe
    color: '#2c3e50',
    textTransform: 'uppercase',
    fontSize: '12px'
  }}>
    {sansthaName}
  </p>
  <h2 style={{ 
    margin: '0', // h2 cha sagla margin remove kela
    color: '#2c3e50',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    fontSize: '22px',
  }}>
    {schoolName}
  </h2>
</div>

      <div
    style={{
      position: 'absolute',
      bottom: '0',
      left: '50%',
      transform: 'translateX(-50%)',
      fontSize: '12px',
      color: 'black',
      whiteSpace: 'nowrap',
      textAlign: 'center',
      width: '100%',
      paddingBottom: '0',
      margin:'-8px'
    }}
  >
    <span>
      {taluka && jilha && (
        <>
          {language === 'English' ? 'Tal: ' : 'तालुका :'} {taluka},{' '}
          {language === 'English' ? 'Dist: ' : 'जिल्हा :'} {jilha},{' '}
        </>
      )}
      {mobileNumber && (
        <>
          {language === 'English' ? 'Mob: ' : 'फोन नं. :'} {mobileNumber},{' '}
        </>
      )}
      {udiseNumber && (
        <>
          {language === 'English' ? 'UDISE: ' : 'UDISE:'} {udiseNumber}{' '}
        </>
      )}
    </span>
  </div>
      <div style={{ width: '80px' }}></div> {/* Spacer for alignment */}
    </div>

    {/* Title Section */}
    <div className="title-section" style={{
      background: 'linear-gradient(to right, #3498db, #2c3e50)',
      color: 'white',
      padding: '8px 0',
      borderRadius: '5px',
      marginBottom: '15px',
      position: 'relative',
      zIndex: 1
    }}>
      <h3 style={{ 
        textAlign: 'center', 
        margin: '0',
        fontSize: '18px',
        fontWeight: '600',
        letterSpacing: '1px'
      }}>
        {language === "English" ? "FIRST SEMESTER REPORT CARD" : "विद्यार्थी प्रगती अहवाल"}
      </h3>
      <h4 style={{ 
        textAlign: 'center', 
        margin: '3px 0 0',
        fontSize: '16px',
        fontWeight: '500'
      }}>
        {language === "English" ? `ACADEMIC YEAR ${academicYear}` : `प्रथम सत्र परीक्षा - ${academicYear}`}
      </h4>
    </div>

    {/* Student Basic Info */}
   <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '14px' }}>
                      <div style={{ flex: '1', textAlign: 'left' }}>
                        <label htmlFor="roll-no" style={{ fontSize: '14px' }}>{language === "English" ? "Roll No : " : "हजेरी क्रमांक : "}</label>
                        <span>{selectedStudentResults?.rollNo || '-'}</span>
                      </div>
                      <div style={{ flex: '1', textAlign: 'center' }}>
                        <label htmlFor="Register No" style={{ fontSize: '14px' }}>{language === "English" ? "GR No: " : "रजिस्टर क्रमांक : "}</label>
                        <span>{selectedStudentResults?.registerNo || '-'}</span>
                      </div>
                      <div style={{ flex: '1', textAlign: 'right', }}>
                        {classValue ?
                          <span>{classValue} {selectedStudentResults?.division || '-'} </span>
                          :
                          <span>
                            <label htmlFor="class" style={{ fontSize: '14px' }}>{language === "English" ? "Class : " : "वर्ग : "}</label>
                            {selectedStudentResults?.division || '-'}
                          </span>
                        }
                      </div>
                    </div>
                    <hr style={{
                      width: 'calc(100% + 40px)', height: '2px', backgroundColor: 'black', border: 'none', marginLeft: '-20px', marginRight: '-20px', marginTop: '1px'
                    }} />
                    <div style={{ fontSize: '14px', marginLeft: '30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div style={{ width: '70%' }}>
                        <div>
                          <label htmlFor="student-name" style={{ fontSize: '14px' }}>{language === "English" ? "Student's Name : " : "विद्यार्थ्याचे नाव : "}</label>
                          <span>{selectedStudentResults?.studentName || '-'} {selectedStudentResults?.stdFather || '-'} {selectedStudentResults?.stdSurname || '-'}</span>
                        </div>
                        <div>
                          <label htmlFor="class" style={{ fontSize: '14px' }}>{language === "English" ? "Mother's Name : " : "आईचे वर्ग : "}</label>
                          <span>{selectedStudentResults?.stdMother || '-'} </span>
                        </div>
                        <div>
                          <label htmlFor="class" style={{ fontSize: '14px' }}>{language === "English" ? "Date Of Birth : " : "जन्मतारीख : "}</label>
                          <span>
                            {selectedStudentResults?.dob ?
                              `${new Date(selectedStudentResults.dob).getDate().toString().padStart(2, '0')}/${(new Date(selectedStudentResults.dob).getMonth() + 1).toString().padStart(2, '0')}/${new Date(selectedStudentResults.dob).getFullYear()}`
                              : '-'}
                          </span>
                        </div>
                        <div>
                          <label htmlFor="exam-roll-no" style={{ fontSize: '14px' }}>{language === "English" ? "Exam : " : "परीक्षा सत्र : "}</label>
                          <span>{selectedExamName || '-'}</span>
                        </div>
                      </div>
                      <div style={{ width: '30%' }}>
                        {selectedStudentResults?.stdPhoto && (
                          <img src={selectedStudentResults?.stdPhoto} style={{ width: '80px', height: '80px' }} />
                        )}
                      </div>
                    </div>

    {/* Results Table */}
    {selectedStudentResults?.results ? (
      <div className="results-table" style={{
        marginBottom: '15px',
        position: 'relative',
        zIndex: 1
      }}>
        <table style={{
          width: '100%',
          borderCollapse: 'collapse',
          fontSize: '12px',
          boxShadow: '0 0 10px rgba(0,0,0,0.05)',
        }}>
         <thead>
  <tr>
    <th rowSpan="2" style={{
      padding: '8px',
      border: '1px solid #ddd',
      textAlign: 'center',
      background: 'linear-gradient(to right, #3498db, #2980b9)',
      color: 'white',
      fontWeight: 'bold'
    }}>
      {language === "English" ? "Subject" : "विषय"}
    </th>

    {["Unit Test I", "Unit Test II", "Unit Test III", "Semester I", "Grand Total"].map((title, i) => (
      <th key={i} colSpan="2" style={{
        padding: '8px',
        border: '1px solid #ddd',
        textAlign: 'center',
        background: 'linear-gradient(to right, #3498db, #2980b9)',
        color: 'white',
        fontWeight: 'bold'
      }}>
        {language === "English" ? title : (
          title === "Unit Test I" ? "पहिली चाचणी" :
          title === "Unit Test II" ? "दुसरी चाचणी" :
          title === "Unit Test III" ? "तिसरी चाचणी" :
          title === "Semester I" ? "प्रथम सत्र" :
          "एकूण गुण"
        )}
      </th>
    ))}

    <th rowSpan="2" style={{
      padding: '8px',
      border: '1px solid #ddd',
      textAlign: 'center',
      background: 'linear-gradient(to right, #3498db, #2980b9)',
      color: 'white',
      fontWeight: 'bold'
    }}>
      {language === "English" ? "Grade" : "श्रेणी"}
    </th>
  </tr>

  <tr>
    {Array(5).fill(0).map((_, i) => (
      <React.Fragment key={i}>
        <th style={{
          padding: '6px',
          border: '1px solid #ddd',
          fontWeight: 'normal',
          background: 'linear-gradient(to right, #3498db, #2980b9)',
          color: 'white'
        }}>
          {language === "English" ? (i === 4 ? "Total" : "M.M") : (i === 4 ? "गुण" : "पैकी")}
        </th>
        <th style={{
          padding: '6px',
          border: '1px solid #ddd',
          fontWeight: 'normal',
          background: 'linear-gradient(to right, #3498db, #2980b9)',
          color: 'white'
        }}>
          {language === "English" ? (i === 4 ? "%" : "Obt.M") : (i === 4 ? "%" : "गुण")}
        </th>
      </React.Fragment>
    ))}
  </tr>
</thead>

          
          <tbody>
            {subjectSequence
              .filter((subject) => {
                const grades = selectedStudentResults.results[subject];
                return (
                  grades && (
                    grades.unitTestIObtainMarks ||
                    grades.unitTestIIObtainMarks ||
                    grades.unitTestIIIObtainMarks ||
                    grades.firstSemesterObtainMarks ||
                    grades.unitTestIGrade ||
                    grades.unitTestIIGrade ||
                    grades.unitTestIIIGrade ||
                    grades.firstSemesterGrade
                  )
                );
              })
              .map((subject, index) => {
                const grades = selectedStudentResults.results[subject];
                
                const displayValue = (obtainMarks, outOf, grade, subtype) => {
                  if (subtype === "Grade" && grade) {
                    return grade;
                  } else if (obtainMarks || obtainMarks === 0) {
                    return obtainMarks;
                  }
                  return "AB";
                };
                
                const displayOutOf = (outOf, subtype) => {
                  if (subtype === "Grade") {  
                    return "-";
                  }
                  return outOf || "AB";
                };

                const hasNumericalData = grades.unitTestIObtainMarks || grades.unitTestIIObtainMarks || 
                                        grades.unitTestIIIObtainMarks || grades.firstSemesterObtainMarks;
                
                let totalOutOf = 0;
                let totalObtainMarks = 0;
                let rowPercentage = "-";
                let grade = "-";
                
                if (hasNumericalData) {
                  totalOutOf = (grades.unitTestIOutOf || 0) + (grades.unitTestIIOutOf || 0) + 
                              (grades.unitTestIIIOutOf || 0) + (grades.firstSemesterOutOf || 0);
                  totalObtainMarks = (grades.unitTestIObtainMarks || 0) + (grades.unitTestIIObtainMarks || 0) + 
                                    (grades.unitTestIIIObtainMarks || 0) + (grades.firstSemesterObtainMarks || 0);
                  rowPercentage = totalOutOf > 0 ? ((totalObtainMarks / totalOutOf) * 100).toFixed(2) : "-";
                  grade = rowPercentage !== "-" ? calculateGrade(Number(rowPercentage)) : "-";
                }

                return (
                  <tr key={subject} style={{
                    backgroundColor: index % 2 === 0 ? '#f8f9fa' : 'white',
                    borderBottom: '1px solid #e0e0e0'
                  }}>
                    <td style={{
                      padding: '4px',
                      border: '1px solid #ddd',
                      fontWeight: '500',
                      color: '#2c3e50'
                    }}>
                      {subject.length > 20 ? (
                        <>
                          {subject.substring(0, 20)}<br/>{subject.substring(20)}
                        </>
                      ) : (
                        subject
                      )}
                    </td>
                    
                    <td style={{ padding: '4px', border: '1px solid #ddd', textAlign: 'center' }}>
                      {displayOutOf(grades.unitTestIOutOf, grades.unitTestISubtype)}
                    </td>
                    <td style={{ padding: '4px', border: '1px solid #ddd', textAlign: 'center' }}>
                      {displayValue(grades.unitTestIObtainMarks, grades.unitTestIOutOf, grades.unitTestIGrade, grades.unitTestISubtype)}
                    </td>
                    <td style={{ padding: '4px', border: '1px solid #ddd', textAlign: 'center' }}>
                      {displayOutOf(grades.unitTestIIOutOf, grades.unitTestIISubtype)}
                    </td>
                    <td style={{ padding: '4px', border: '1px solid #ddd', textAlign: 'center' }}>
                      {displayValue(grades.unitTestIIObtainMarks, grades.unitTestIIOutOf, grades.unitTestIIGrade, grades.unitTestIISubtype)}
                    </td>
                    <td style={{ padding: '4px', border: '1px solid #ddd', textAlign: 'center' }}>
                      {displayOutOf(grades.unitTestIIIOutOf, grades.unitTestIIISubtype)}
                    </td>
                    <td style={{ padding: '4px', border: '1px solid #ddd', textAlign: 'center' }}>
                      {displayValue(grades.unitTestIIIObtainMarks, grades.unitTestIIIOutOf, grades.unitTestIIIGrade, grades.unitTestIIISubtype)}
                    </td>
                    <td style={{ padding: '4px', border: '1px solid #ddd', textAlign: 'center' }}>
                      {displayOutOf(grades.firstSemesterOutOf, grades.firstSemesterSubtype)}
                    </td>
                    <td style={{ padding: '4px', border: '1px solid #ddd', textAlign: 'center' }}>
                      {displayValue(grades.firstSemesterObtainMarks, grades.firstSemesterOutOf, grades.firstSemesterGrade, grades.firstSemesterSubtype)}
                    </td>
                    <td style={{ 
                      padding: '4px', 
                      border: '1px solid #ddd', 
                      textAlign: 'center',
                      fontWeight: '600',
                      
                    }}>
                      {hasNumericalData ? `${totalObtainMarks}/${totalOutOf}` : "-"}
                    </td>
                    <td style={{ 
                      padding: '4px', 
                      border: '1px solid #ddd', 
                      textAlign: 'center',
                      fontWeight: '600'
                    }}>
                      {rowPercentage}
                    </td>
                    <td style={{ 
                      padding: '4px', 
                      border: '1px solid #ddd', 
                      textAlign: 'center',
                      fontWeight: '600',
                      color: '#27ae60'
                    }}>
                      {grade}
                    </td>
                  </tr>
                );
              })}
              
              {/* Totals Row */}
              {selectedStudentResults && selectedStudentResults.results && (
                <tr style={{
                  backgroundColor: '#f1f8e9',
                  fontWeight: 'bold'
                }}>
                  <td style={{ padding: '4px', border: '1px solid #ddd' }}>
                    {language === "English" ? "Total Marks" : "एकूण गुण"}
                  </td>
                  {["unitTestIOutOf", "unitTestIObtainMarks", "unitTestIIOutOf", "unitTestIIObtainMarks", "unitTestIIIOutOf", "unitTestIIIObtainMarks", "firstSemesterOutOf", "firstSemesterObtainMarks"].map((key, index) => (
                    <td key={index} style={{ padding: '4px', border: '1px solid #ddd', textAlign: 'center' }}>
                      {subjectSequence
                        .filter(subject => {
                          const grades = selectedStudentResults.results[subject] || {};
                          return grades.unitTestIObtainMarks || grades.unitTestIIObtainMarks || grades.unitTestIIIObtainMarks || grades.firstSemesterObtainMarks;
                        })
                        .reduce((total, subject) => {
                          const grades = selectedStudentResults.results[subject] || {};
                          return total + (grades[key] || 0);
                        }, 0)}
                    </td>
                  ))}
                  <td style={{ padding: '4px', border: '1px solid #ddd', textAlign: 'center' }}>
                    {subjectSequence
                      .filter(subject => {
                        const grades = selectedStudentResults.results[subject] || {};
                        return grades.unitTestIObtainMarks || grades.unitTestIIObtainMarks || grades.unitTestIIIObtainMarks || grades.firstSemesterObtainMarks;
                      })
                      .reduce((total, subject) => {
                        const grades = selectedStudentResults.results[subject] || {};
                        return total + (grades.unitTestIObtainMarks || 0) + (grades.unitTestIIObtainMarks || 0) + (grades.unitTestIIIObtainMarks || 0) + (grades.firstSemesterObtainMarks || 0);
                      }, 0)}
                    / 
                    {subjectSequence
                      .filter(subject => {
                        const grades = selectedStudentResults.results[subject] || {};
                        return grades.unitTestIObtainMarks || grades.unitTestIIObtainMarks || grades.unitTestIIIObtainMarks || grades.firstSemesterObtainMarks;
                      })
                      .reduce((total, subject) => {
                        const grades = selectedStudentResults.results[subject] || {};
                        return total + (grades.unitTestIOutOf || 0) + (grades.unitTestIIOutOf || 0) + (grades.unitTestIIIOutOf || 0) + (grades.firstSemesterOutOf || 0);
                      }, 0)}
                  </td>
                  <td style={{ padding: '4px', border: '1px solid #ddd', textAlign: 'center' }}>
                    {(() => {
                      const filteredSubjects = subjectSequence.filter(subject => {
                        const grades = selectedStudentResults.results[subject] || {};
                        return grades.unitTestIObtainMarks || grades.unitTestIIObtainMarks || grades.unitTestIIIObtainMarks || grades.firstSemesterObtainMarks;
                      });
                      const totalMaxMarks = filteredSubjects.reduce((total, subject) => {
                        const grades = selectedStudentResults.results[subject] || {};
                        return total + (grades.unitTestIOutOf || 0) + (grades.unitTestIIOutOf || 0) + (grades.unitTestIIIOutOf || 0) + (grades.firstSemesterOutOf || 0);
                      }, 0);
                      const totalObtainedMarks = filteredSubjects.reduce((total, subject) => {
                        const grades = selectedStudentResults.results[subject] || {};
                        return total + (grades.unitTestIObtainMarks || 0) + (grades.unitTestIIObtainMarks || 0) + (grades.unitTestIIIObtainMarks || 0) + (grades.firstSemesterObtainMarks || 0);
                      }, 0);
                      return totalMaxMarks > 0 ? ((totalObtainedMarks / totalMaxMarks) * 100).toFixed(2) + '%' : '0%';
                    })()}
                  </td>
                  <td style={{ padding: '4px', border: '1px solid #ddd', textAlign: 'center' }}>
                    {(() => {
                      const filteredSubjects = subjectSequence.filter(subject => {
                        const grades = selectedStudentResults.results[subject] || {};
                        return grades.unitTestIObtainMarks || grades.unitTestIIObtainMarks || grades.unitTestIIIObtainMarks || grades.firstSemesterObtainMarks;
                      });
                      const totalMaxMarks = filteredSubjects.reduce((total, subject) => {
                        const grades = selectedStudentResults.results[subject] || {};
                        return total + (grades.unitTestIOutOf || 0) + (grades.unitTestIIOutOf || 0) + (grades.unitTestIIIOutOf || 0) + (grades.firstSemesterOutOf || 0);
                      }, 0);
                      const totalObtainedMarks = filteredSubjects.reduce((total, subject) => {
                        const grades = selectedStudentResults.results[subject] || {};
                        return total + (grades.unitTestIObtainMarks || 0) + (grades.unitTestIIObtainMarks || 0) + (grades.unitTestIIIObtainMarks || 0) + (grades.firstSemesterObtainMarks || 0);
                      }, 0);
                      const percentage = totalMaxMarks > 0 ? (totalObtainedMarks / totalMaxMarks) * 100 : 0;
                      return language === 'English' ? calculateGradeEnglish(percentage) : calculateGradeMarathi(percentage);
                    })()}
                  </td>
                </tr>
              )}
              
              {/* Remarks Row */}
              {selectedStudentResults && selectedStudentResults.results && (
                <tr>
                  <td style={{ padding: '4px', border: '1px solid #ddd', fontWeight: 'bold' }}>
                    {language === "English" ? "Remarks" : "शेरा"}
                  </td>
                  <td colSpan="11" style={{ padding: '4px', border: '1px solid #ddd' }}>
                     <input
                      type="text"
                      id="remark-input"
                      placeholder="Enter Remark"
  value={remarkText}
  onChange={(e) => setRemarkText(e.target.value)}
                      style={{
                        border: 'none',
                        borderBottom: '1px solid transparent',
                        outline: 'none',
                       
                        background: 'transparent',
                       
                        fontSize: '12px'
                      }}
                    />
                  </td>
                </tr>
              )}
          </tbody>
        </table>
      </div>
    ) : (
      <div style={{
        padding: '20px',
        textAlign: 'center',
        color: '#7f8c8d',
        fontStyle: 'italic'
      }}>
        {language === "English" ? "No results available." : "कोणतेही प्रगतीपत्रक उपलब्ध नाहीत."}
      </div>
    )}

    {/* Summary Section */}
    <div className="summary" style={{
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: '10px',
      padding: '8px',
      background: '#f5f5f5',
      borderRadius: '5px',
      border: '1px solid #e0e0e0',
      position: 'relative',
      zIndex: 1,
      fontSize: '12px'
    }}>
      <div style={{ flex: 1 }}>
        <div style={{ marginBottom: '10px' }}>
          <span style={{ fontWeight: '600', marginRight: '10px' }}>
            {language === "English" ? "Out Of:" : "एकूण:"}
          </span>
          <span style={{ fontWeight: '600' }}>
            {subjectSequence
              .filter(subject => {
                const grades = selectedStudentResults?.results?.[subject] || {};
                return grades.unitTestIObtainMarks || grades.unitTestIIObtainMarks || grades.unitTestIIIObtainMarks || grades.firstSemesterObtainMarks;
              })
              .reduce((total, subject) => {
                const grades = selectedStudentResults?.results?.[subject] || {};
                return total + (grades.unitTestIOutOf || 0) + (grades.unitTestIIOutOf || 0) + (grades.unitTestIIIOutOf || 0) + (grades.firstSemesterOutOf || 0);
              }, 0)}
          </span>
        </div>
        
        <div style={{ marginBottom: '10px' }}>
          <span style={{ fontWeight: '600', marginRight: '10px' }}>
            {language === "English" ? "Obtained Marks:" : "प्राप्त गुण:"}
          </span>
          <span style={{ fontWeight: '600' }}>
            {subjectSequence.reduce((total, subject) => {
              const grades = selectedStudentResults?.results?.[subject] || {};
              return (
                total +
                (grades.unitTestIObtainMarks || 0) +
                (grades.unitTestIIObtainMarks || 0) +
                (grades.unitTestIIIObtainMarks || 0) +
                (grades.firstSemesterObtainMarks || 0)
              );
            }, 0)}
          </span>
        </div>
        
        <div>
          <span style={{ fontWeight: '600', marginRight: '10px' }}>
            {language === "English" ? "Attendance:" : "उपस्थिती:"}
          </span>
          <input
            type="text"
            id="attendance"
            placeholder={language === "English" ? "Enter attendance" : "उपस्थिती प्रविष्ट करा"}
            value={attendance}
            onChange={(e) => setAttendance(e.target.value)}
            style={{
              border: 'none',
              borderBottom: '1px solid #7f8c8d',
              outline: 'none',
              padding: '5px 0',
              background: 'transparent',
              width: '80px',
              fontWeight: '600'
            }}
          />
        </div>
      </div>
      
      <div style={{ flex: 1, textAlign: 'right' }}>
        <div style={{ marginBottom: '10px' }}>
          <span style={{ fontWeight: '600', marginRight: '10px' }}>
            {language === "English" ? "Percentage:" : "टक्केवारी:"}
          </span>
          <span style={{ fontWeight: '600', color: '#27ae60' }}>
            {(() => {
              const filteredSubjects = subjectSequence.filter(subject => {
                const grades = selectedStudentResults?.results?.[subject] || {};
                return (
                  grades.unitTestIObtainMarks > 0 ||
                  grades.unitTestIIObtainMarks > 0 ||
                  grades.unitTestIIIObtainMarks > 0 ||
                  grades.firstSemesterObtainMarks > 0
                );
              });

              const totalMaxMarks = filteredSubjects.reduce((total, subject) => {
                const grades = selectedStudentResults?.results?.[subject] || {};
                return (
                  total +
                  (grades.unitTestIOutOf || 0) +
                  (grades.unitTestIIOutOf || 0) +
                  (grades.unitTestIIIOutOf || 0) +
                  (grades.firstSemesterOutOf || 0)
                );
              }, 0);

              const totalObtainedMarks = filteredSubjects.reduce((total, subject) => {
                const grades = selectedStudentResults?.results?.[subject] || {};
                return (
                  total +
                  (grades.unitTestIObtainMarks || 0) +
                  (grades.unitTestIIObtainMarks || 0) +
                  (grades.unitTestIIIObtainMarks || 0) +
                  (grades.firstSemesterObtainMarks || 0)
                );
              }, 0);

              return totalMaxMarks > 0
                ? ((totalObtainedMarks / totalMaxMarks) * 100).toFixed(2) + "%"
                : "0%";
            })()}
          </span>
        </div>
        
        <div>
          <span style={{ fontWeight: '600', marginRight: '10px' }}>
            {language === "English" ? "Overall Grade:" : "एकूण श्रेणी:"}
          </span>
          <span style={{ 
            fontWeight: 'bold', 
            color: '#27ae60',
            padding: '3px 10px',
            borderRadius: '3px',
            background: '#e8f5e9'
          }}>
            {(() => {
              const filteredSubjects = subjectSequence.filter(subject => {
                const grades = selectedStudentResults?.results?.[subject] || {};
                return grades.unitTestIObtainMarks || grades.unitTestIIObtainMarks || grades.unitTestIIIObtainMarks || grades.firstSemesterObtainMarks;
              });
              const totalMaxMarks = filteredSubjects.reduce((total, subject) => {
                const grades = selectedStudentResults?.results?.[subject] || {};
                return total + (grades.unitTestIOutOf || 0) + (grades.unitTestIIOutOf || 0) + (grades.unitTestIIIOutOf || 0) + (grades.firstSemesterOutOf || 0);
              }, 0);
              const totalObtainedMarks = filteredSubjects.reduce((total, subject) => {
                const grades = selectedStudentResults?.results?.[subject] || {};
                return total + (grades.unitTestIObtainMarks || 0) + (grades.unitTestIIObtainMarks || 0) + (grades.unitTestIIIObtainMarks || 0) + (grades.firstSemesterObtainMarks || 0);
              }, 0);
              const percentage = totalMaxMarks > 0 ? (totalObtainedMarks / totalMaxMarks) * 100 : 0;
              return language === 'English' ? calculateGradeEnglish(percentage) : calculateGradeMarathi(percentage);
            })()}
          </span>
        </div>
      </div>
    </div>

    {/* Signatures Section */}
    <div className="signatures" style={{
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: '30px',
      paddingTop: '20px',
    
      position: 'relative',
      zIndex: 1
    }}>
      <div style={{ textAlign: 'center', width: '30%' }}>
        <div style={{
          height: '1px',
          background: '#7f8c8d',
          marginBottom: '10px'
        }}></div>
        <div style={{ fontWeight: '600' }}>
          {language === "English" ? "Parent's Sign" : "पालकांची सही"}
        </div>
      </div>
      
      <div style={{ textAlign: 'center', width: '30%' }}>
        <div style={{
          height: '1px',
          background: '#7f8c8d',
          marginBottom: '10px'
        }}></div>
        <div style={{ fontWeight: '600' }}>
          {language === "English" ? "Class Teacher Sign" : "वर्गशिक्षक"}
        </div>
      </div>
      
      <div style={{ textAlign: 'center', width: '30%' }}>
        <div style={{
          height: '1px',
          background: '#7f8c8d',
          marginBottom: '10px'
        }}></div>
        <div style={{ fontWeight: '600' }}>
          {language === "English" ? "Principal Sign" : "प्राचार्य"}
        </div>
      </div>
    </div>

  </div>
</div>



            ) :  (




              <div className="r mt-1">
                <div className="left" style={{
                  width: '985px',
                  height: '690px',
                  margin: '0 auto',
                  padding: '20px',
                  border: '2px solid #000',
                  boxSizing: 'border-box',
                  overflow: 'hidden'
                }}>

                  <div className="school-header" style={{ marginBottom: '10px', position: 'relative' }}>
                    {/* Logo + School Name container */}
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      flexWrap: 'wrap',
                      padding: '0 10px'
                    }}>
                      {/* Logo aligned left */}
                      {schoolLogo && (
                        <div style={{ flex: '0 0 auto' }}>
                          <img
                            src={schoolLogo}
                            alt="Logo"
                            style={{
                              width: '70px',
                              height: 'auto',
                              objectFit: 'contain'
                            }}
                          />
                        </div>
                      )}

                      {/* School name centered */}
                      <div style={{ flex: '1', textAlign: 'center' }}>
                        <h4 style={{ fontSize: '22px', margin: 0 }}>{schoolName}</h4>
                      </div>
 {/* <div
    style={{
      position: 'absolute',
      bottom: '0',
      left: '50%',
      transform: 'translateX(-50%)',
      fontSize: '12px',
      color: 'black',
      whiteSpace: 'nowrap',
      textAlign: 'center',
      width: '100%',
      paddingBottom: '0',
    }}
  >
    <span>
      {taluka && jilha && (
        <>
          {language === 'English' ? 'Tal: ' : 'तालुका :'} {taluka},{' '}
          {language === 'English' ? 'Dist: ' : 'जिल्हा :'} {jilha},{' '}
        </>
      )}
      {mobileNumber && (
        <>
          {language === 'English' ? 'Mob: ' : 'फोन नं. :'} {mobileNumber},{' '}
        </>
      )}
      {udiseNumber && (
        <>
          {language === 'English' ? 'UDISE: ' : 'UDISE:'} {udiseNumber}{' '}
        </>
      )}
    </span>
  </div> */}
                      {/* Empty space to balance flex alignment */}
                      <div style={{ width: '70px' }}></div>
                    </div>
                    <div class="ribbon" > PROGRESS REPORT</div>
                      <style jsx >
                        {`
                          /* HTML: <div class="ribbon">Your text content</div> */
                        .ribbon {
                          font-size: 18px;
                          font-weight: bold;
                          display: table;
                          color: #fff;

                        }
                        .ribbon {
                          --s: 1.8em; /* the ribbon size */
                          --d: .8em;  /* the depth */
                          --c: .8em;  /* the cutout part */
                          
                          padding: 0 calc(var(--s) + .5em) var(--d);
                          line-height: 1.8;
                          background:
                          conic-gradient(at left  var(--s) bottom var(--d),
                          #0000 25%,#0008 0 37.5%,#0004 0) 0   /50% 100% no-repeat,
                          conic-gradient(at right var(--s) bottom var(--d),
                          #0004 62.5%,#0008 0 75%,#0000 0) 100%/50% 100% no-repeat;
                          clip-path: polygon(0 var(--d), var(--s) var(--d),var(--s) 0,calc(100% - var(--s)) 0,calc(100% - var(--s)) var(--d),100% var(--d),calc(100% - var(--c)) calc(50% + var(--d)/2),100% 100%,calc(100% - var(--s) - var(--d)) 100%,calc(100% - var(--s) - var(--d)) calc(100% - var(--d)),calc(var(--s) + var(--d)) calc(100% - var(--d)),calc(var(--s) + var(--d)) 100%,0 100%,var(--c) calc(50% + var(--d)/2));
                          background-color: #CC333F; /* the main color */
                          width: fit-content;
                          margin: 0px auto;
                          display: table;
                        }
                      `}
                      </style>


                    {/* </div> */}
                  </div>



                  <div style={{ marginTop: '-20px', fontSize: '12px', marginLeft: '30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    {/* Left Section (Student Details) */}
                    <div style={{ width: '70%' }}>
                      <div>
                        <label htmlFor="student-name" style={{ fontSize: '12px' }}>{language === "English" ? "Student's Name : " : "विद्यार्थ्याचे नाव : "}</label>
                        <span>{selectedStudentResults?.studentName || '-'} {selectedStudentResults?.stdFather || '-'} {selectedStudentResults?.stdSurname || '-'}</span>
                      </div>
                      <div>
                        <label htmlFor="class" style={{ fontSize: '12px' }}>{language === "English" ? "Mother's Name : " : "आईचे वर्ग : "}</label>
                        <span>{selectedStudentResults?.stdMother || '-'} </span>
                      </div>
                      <div>
                        <label htmlFor="class" style={{ fontSize: '12px' }}>{language === "English" ? "Date Of Birth : " : "जन्मतारीख : "}</label>
                        <span>
                          {selectedStudentResults?.dob ?
                            `${new Date(selectedStudentResults.dob).getDate().toString().padStart(2, '0')}/${(new Date(selectedStudentResults.dob).getMonth() + 1).toString().padStart(2, '0')}/${new Date(selectedStudentResults.dob).getFullYear()}`
                            : '-'}
                        </span>
                      </div>
                      <div>
                        <label htmlFor="exam-roll-no" style={{ fontSize: '12px' }}>{language === "English" ? "Year : " : "शैक्षणिक वर्ष : "}</label>
                        <span>{academicYear || '-'}</span>
                      </div>
                    </div>

                    {/* Middle Section (Roll No, Register No, Class) */}
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', flex: '1', marginRight: '20px' }}>
                      <div>
                        <label htmlFor="roll-no" style={{ fontSize: '12px' }}>{language === "English" ? "Roll No : " : "हजेरी क्रमांक : "}</label>
                        <span>{selectedStudentResults?.rollNo || '-'}</span>
                      </div>
                      <div>
                        <label htmlFor="Register No" style={{ fontSize: '12px' }}>{language === "English" ? "GR No: " : "रजिस्टर क्रमांक : "}</label>
                        <span>{selectedStudentResults?.registerNo || '-'}</span>
                      </div>
                      <div>
                        {classValue ?
                          <span>{classValue} {selectedStudentResults?.division || '-'} </span>
                          :
                          <span>
                            <label htmlFor="class" style={{ fontSize: '12px' }}>{language === "English" ? "Class : " : "वर्ग : "}</label>
                            {selectedStudentResults?.division || '-'}
                          </span>
                        }
                      </div>
                    </div>

                    {/* Right Section (Student Image) */}
                    <div style={{ width: '30%', marginRight: '-150px' }}>
                      {selectedStudentResults?.stdPhoto && (
                        <img src={selectedStudentResults?.stdPhoto} style={{ width: '80px', height: '80px' }} />
                      )}
                    </div>
                  </div>

                  {selectedStudentResults?.results ? (
      <div className="results-table" style={{
        marginBottom: '15px',
        position: 'relative',
        zIndex: 1
      }}>
        <table style={{
          width: '100%',
          borderCollapse: 'collapse',
          fontSize: '10px',
          boxShadow: '0 0 10px rgba(0,0,0,0.05)',
        }}>
          <thead>
            <tr>
              <th rowSpan="2" style={{
                padding: '8px',
                border: '1px solid #ddd',
                textAlign: 'center',
                background: 'linear-gradient(to right, #3498db, #2980b9)',
                color: 'white',
                fontWeight: 'bold'
              }}>
                {language === "English" ? "Subject" : "विषय"}
              </th>
              {["Unit Test I", "Unit Test II", "Unit Test III", "Unit Test IV", "Unit Test V", "Unit Test VI", "Semester I", "Semester II", "Grand Total"].map((title, i) => (
                <th key={i} colSpan="2" style={{
                  padding: '8px',
                  border: '1px solid #ddd',
                  textAlign: 'center',
                  background: 'linear-gradient(to right, #3498db, #2980b9)',
                  color: 'white',
                  fontWeight: 'bold'
                }}>
                  {language === "English" ? title : (
                    title === "Unit Test I" ? "पहिली चाचणी" :
                    title === "Unit Test II" ? "दुसरी चाचणी" :
                    title === "Unit Test III" ? "तिसरी चाचणी" :
                    title === "Unit Test IV" ? "चतुर्थ चाचणी" :
                    title === "Unit Test V" ? "पंचम चाचणी" :
                    title === "Unit Test VI" ? "षष्ठ चाचणी" :
                    title === "Semester I" ? "प्रथम सत्र" :
                    title === "Semester II" ? "द्वितीय सत्र" :
                    "एकूण गुण"
                  )}
                </th>
              ))}
              <th rowSpan="2" style={{
                padding: '8px',
                border: '1px solid #ddd',
                textAlign: 'center',
                background: 'linear-gradient(to right, #3498db, #2980b9)',
                color: 'white',
                fontWeight: 'bold'
              }}>
                {language === "English" ? "Grade" : "श्रेणी"}
              </th>
            </tr>
            <tr>
              {Array(9).fill(0).map((_, i) => (
                <React.Fragment key={i}>
                  <th style={{
                    padding: '6px',
                    border: '1px solid #ddd',
                    fontWeight: 'normal',
                    background: 'linear-gradient(to right, #3498db, #2980b9)',
                    color: 'white'
                  }}>
                    {language === "English" ? (i === 8 ? "Total" : "M.M") : (i === 8 ? "गुण" : "पैकी")}
                  </th>
                  <th style={{
                    padding: '6px',
                    border: '1px solid #ddd',
                    fontWeight: 'normal',
                    background: 'linear-gradient(to right, #3498db, #2980b9)',
                    color: 'white'
                  }}>
                    {language === "English" ? (i === 8 ? "%" : "Obt.M") : (i === 8 ? "%" : "गुण")}
                  </th>
                </React.Fragment>
              ))}
            </tr>
          </thead>
          <tbody>
            {subjectSequence
              .filter((subject) => {
                const grades = selectedStudentResults.results[subject];
                return (
                  grades && (
                    grades.unitTestIObtainMarks ||
                    grades.unitTestIIObtainMarks ||
                    grades.unitTestIIIObtainMarks ||
                    grades.unitTestIVObtainMarks ||
                    grades.unitTestVObtainMarks ||
                    grades.unitTestVIObtainMarks ||
                    grades.firstSemesterObtainMarks ||
                    grades.secondSemesterObtainMarks ||
                    grades.unitTestIGrade ||
                    grades.unitTestIIGrade ||
                    grades.unitTestIIIGrade ||
                    grades.unitTestIVGrade ||
                    grades.unitTestVGrade ||
                    grades.unitTestVIGrade ||
                    grades.firstSemesterGrade ||
                    grades.secondSemesterGrade
                  )
                );
              })
              .map((subject, index) => {
                const grades = selectedStudentResults.results[subject];
                
                const displayValue = (obtainMarks, outOf, grade, subtype) => {
                  if (subtype === "Grade" && grade) {
                    return grade;
                  } else if (obtainMarks || obtainMarks === 0) {
                    return obtainMarks;
                  }
                  return "AB";
                };
                
                const displayOutOf = (outOf, subtype) => {
                  if (subtype === "Grade") {
                    return "-";
                  }
                  return outOf || "AB";
                };

                const hasNumericalData = grades.unitTestIObtainMarks || grades.unitTestIIObtainMarks || 
                                        grades.unitTestIIIObtainMarks || grades.unitTestIVObtainMarks ||
                                        grades.unitTestVObtainMarks || grades.unitTestVIObtainMarks ||
                                        grades.firstSemesterObtainMarks || grades.secondSemesterObtainMarks;
                
                let totalOutOf = 0;
                let totalObtainMarks = 0;
                let rowPercentage = "-";
                let grade = "-";
                
                if (hasNumericalData) {
                  totalOutOf = (grades.unitTestIOutOf || 0) + (grades.unitTestIIOutOf || 0) + 
                              (grades.unitTestIIIOutOf || 0) + (grades.unitTestIVOutOf || 0) +
                              (grades.unitTestVOutOf || 0) + (grades.unitTestVIOutOf || 0) +
                              (grades.firstSemesterOutOf || 0) + (grades.secondSemesterOutOf || 0);
                  totalObtainMarks = (grades.unitTestIObtainMarks || 0) + (grades.unitTestIIObtainMarks || 0) + 
                                    (grades.unitTestIIIObtainMarks || 0) + (grades.unitTestIVObtainMarks || 0) +
                                    (grades.unitTestVObtainMarks || 0) + (grades.unitTestVIObtainMarks || 0) +
                                    (grades.firstSemesterObtainMarks || 0) + (grades.secondSemesterObtainMarks || 0);
                  rowPercentage = totalOutOf > 0 ? ((totalObtainMarks / totalOutOf) * 100).toFixed(2) : "-";
                  grade = rowPercentage !== "-" ? calculateGrade(Number(rowPercentage)) : "-";
                }

                return (
                  <tr key={subject} style={{
                    backgroundColor: index % 2 === 0 ? '#f8f9fa' : 'white',
                    borderBottom: '1px solid #e0e0e0'
                  }}>
                    <td style={{
                      padding: '4px',
                      border: '1px solid #ddd',
                      fontWeight: '500',
                      color: '#2c3e50'
                    }}>
                      {subject.length > 20 ? (
                        <>
                          {subject.substring(0, 20)}<br/>{subject.substring(20)}
                        </>
                      ) : (
                        subject
                      )}
                    </td>
                    
                    <td style={{ padding: '4px', border: '1px solid #ddd', textAlign: 'center' }}>
                      {displayOutOf(grades.unitTestIOutOf, grades.unitTestISubtype)}
                    </td>
                    <td style={{ padding: '4px', border: '1px solid #ddd', textAlign: 'center' }}>
                      {displayValue(grades.unitTestIObtainMarks, grades.unitTestIOutOf, grades.unitTestIGrade, grades.unitTestISubtype)}
                    </td>
                    <td style={{ padding: '4px', border: '1px solid #ddd', textAlign: 'center' }}>
                      {displayOutOf(grades.unitTestIIOutOf, grades.unitTestIISubtype)}
                    </td>
                    <td style={{ padding: '4px', border: '1px solid #ddd', textAlign: 'center' }}>
                      {displayValue(grades.unitTestIIObtainMarks, grades.unitTestIIOutOf, grades.unitTestIIGrade, grades.unitTestIISubtype)}
                    </td>
                    <td style={{ padding: '4px', border: '1px solid #ddd', textAlign: 'center' }}>
                      {displayOutOf(grades.unitTestIIIOutOf, grades.unitTestIIISubtype)}
                    </td>
                    <td style={{ padding: '4px', border: '1px solid #ddd', textAlign: 'center' }}>
                      {displayValue(grades.unitTestIIIObtainMarks, grades.unitTestIIIOutOf, grades.unitTestIIIGrade, grades.unitTestIIISubtype)}
                    </td>
                    <td style={{ padding: '4px', border: '1px solid #ddd', textAlign: 'center' }}>
                      {displayOutOf(grades.unitTestIVOutOf, grades.unitTestIVSubtype)}
                    </td>
                    <td style={{ padding: '4px', border: '1px solid #ddd', textAlign: 'center' }}>
                      {displayValue(grades.unitTestIVObtainMarks, grades.unitTestIVOutOf, grades.unitTestIVGrade, grades.unitTestIVSubtype)}
                    </td>
                    <td style={{ padding: '4px', border: '1px solid #ddd', textAlign: 'center' }}>
                      {displayOutOf(grades.unitTestVOutOf, grades.unitTestVSubtype)}
                    </td>
                    <td style={{ padding: '4px', border: '1px solid #ddd', textAlign: 'center' }}>
                      {displayValue(grades.unitTestVObtainMarks, grades.unitTestVOutOf, grades.unitTestVGrade, grades.unitTestVSubtype)}
                    </td>
                    <td style={{ padding: '4px', border: '1px solid #ddd', textAlign: 'center' }}>
                      {displayOutOf(grades.unitTestVIOutOf, grades.unitTestVISubtype)}
                    </td>
                    <td style={{ padding: '4px', border: '1px solid #ddd', textAlign: 'center' }}>
                      {displayValue(grades.unitTestVIObtainMarks, grades.unitTestVIOutOf, grades.unitTestVIGrade, grades.unitTestVISubtype)}
                    </td>
                    <td style={{ padding: '4px', border: '1px solid #ddd', textAlign: 'center' }}>
                      {displayOutOf(grades.firstSemesterOutOf, grades.firstSemesterSubtype)}
                    </td>
                    <td style={{ padding: '4px', border: '1px solid #ddd', textAlign: 'center' }}>
                      {displayValue(grades.firstSemesterObtainMarks, grades.firstSemesterOutOf, grades.firstSemesterGrade, grades.firstSemesterSubtype)}
                    </td>
                    <td style={{ padding: '4px', border: '1px solid #ddd', textAlign: 'center' }}>
                      {displayOutOf(grades.secondSemesterOutOf, grades.secondSemesterSubtype)}
                    </td>
                    <td style={{ padding: '4px', border: '1px solid #ddd', textAlign: 'center' }}>
                      {displayValue(grades.secondSemesterObtainMarks, grades.secondSemesterOutOf, grades.secondSemesterGrade, grades.secondSemesterSubtype)}
                    </td>
                    <td style={{ 
                      padding: '4px', 
                      border: '1px solid #ddd', 
                      textAlign: 'center',
                      fontWeight: '600',
                    }}>
                      {hasNumericalData ? `${totalObtainMarks}/${totalOutOf}` : "-"}
                    </td>
                    <td style={{ 
                      padding: '4px', 
                      border: '1px solid #ddd', 
                      textAlign: 'center',
                      fontWeight: '600'
                    }}>
                      {rowPercentage}
                    </td>
                    <td style={{ 
                      padding: '4px', 
                      border: '1px solid #ddd', 
                      textAlign: 'center',
                      fontWeight: '600',
                      color: '#27ae60'
                    }}>
                      {grade}
                    </td>
                  </tr>
                );
              })}
              
              {/* Totals Row */}
              {selectedStudentResults && selectedStudentResults.results && (
                <tr style={{
                  backgroundColor: '#f1f8e9',
                  fontWeight: 'bold'
                }}>
                  <td style={{ padding: '4px', border: '1px solid #ddd' }}>
                    {language === "English" ? "Total Marks" : "एकूण गुण"}
                  </td>
                  {["unitTestIOutOf", "unitTestIObtainMarks", "unitTestIIOutOf", "unitTestIIObtainMarks", "unitTestIIIOutOf", "unitTestIIIObtainMarks", "unitTestIVOutOf", "unitTestIVObtainMarks", "unitTestVOutOf", "unitTestVObtainMarks", "unitTestVIOutOf", "unitTestVIObtainMarks", "firstSemesterOutOf", "firstSemesterObtainMarks", "secondSemesterOutOf", "secondSemesterObtainMarks"].map((key, index) => (
                    <td key={index} style={{ padding: '4px', border: '1px solid #ddd', textAlign: 'center' }}>
                      {subjectSequence
                        .filter(subject => {
                          const grades = selectedStudentResults.results[subject] || {};
                          return grades.unitTestIObtainMarks || grades.unitTestIIObtainMarks || grades.unitTestIIIObtainMarks || grades.unitTestIVObtainMarks || grades.unitTestVObtainMarks || grades.unitTestVIObtainMarks || grades.firstSemesterObtainMarks || grades.secondSemesterObtainMarks;
                        })
                        .reduce((total, subject) => {
                          const grades = selectedStudentResults.results[subject] || {};
                          return total + (grades[key] || 0);
                        }, 

                        0)}
                    </td>
                  ))}
                  <td style={{ padding: '4px', border: '1px solid #ddd', textAlign: 'center' }}>
                    {subjectSequence
                      .filter(subject => {
                        const grades = selectedStudentResults.results[subject] || {};
                        return grades.unitTestIObtainMarks || grades.unitTestIIObtainMarks || grades.unitTestIIIObtainMarks || grades.unitTestIVObtainMarks || grades.unitTestVObtainMarks || grades.unitTestVIObtainMarks || grades.firstSemesterObtainMarks || grades.secondSemesterObtainMarks;
                      })
                      .reduce((total, subject) => {
                        const grades = selectedStudentResults.results[subject] || {};
                        return total + (grades.unitTestIObtainMarks || 0) + (grades.unitTestIIObtainMarks || 0) + (grades.unitTestIIIObtainMarks || 0) + (grades.unitTestIVObtainMarks || 0) + (grades.unitTestVObtainMarks || 0) + (grades.unitTestVIObtainMarks || 0) + (grades.firstSemesterObtainMarks || 0) + (grades.secondSemesterObtainMarks || 0);
                      }, 0)}
                  </td>
                  <td style={{ padding: '4px', border: '1px solid #ddd', textAlign: 'center' }}>
                    {(() => {
                      const filteredSubjects = subjectSequence.filter(subject => {
                        const grades = selectedStudentResults.results[subject] || {};
                        return grades.unitTestIObtainMarks || grades.unitTestIIObtainMarks || grades.unitTestIIIObtainMarks || grades.unitTestIVObtainMarks || grades.unitTestVObtainMarks || grades.unitTestVIObtainMarks || grades.firstSemesterObtainMarks || grades.secondSemesterObtainMarks;
                      });
                      const totalMaxMarks = filteredSubjects.reduce((total, subject) => {
                        const grades = selectedStudentResults.results[subject] || {};
                        return total + (grades.unitTestIOutOf || 0) + (grades.unitTestIIOutOf || 0) + (grades.unitTestIIIOutOf || 0) + (grades.unitTestIVOutOf || 0) + (grades.unitTestVOutOf || 0) + (grades.unitTestVIOutOf || 0) + (grades.firstSemesterOutOf || 0) + (grades.secondSemesterOutOf || 0);
                      }, 0);
                      const totalObtainedMarks = filteredSubjects.reduce((total, subject) => {
                        const grades = selectedStudentResults.results[subject] || {};
                        return total + (grades.unitTestIObtainMarks || 0) + (grades.unitTestIIObtainMarks || 0) + (grades.unitTestIIIObtainMarks || 0) + (grades.unitTestIVObtainMarks || 0) + (grades.unitTestVObtainMarks || 0) + (grades.unitTestVIObtainMarks || 0) + (grades.firstSemesterObtainMarks || 0) + (grades.secondSemesterObtainMarks || 0);
                      }, 0);
                      return totalMaxMarks > 0 ? ((totalObtainedMarks / totalMaxMarks) * 100).toFixed(2) + '%' : '0%';
                    })()}
                  </td>
                  <td style={{ padding: '4px', border: '1px solid #ddd', textAlign: 'center' }}>
                    {(() => {
                      const filteredSubjects = subjectSequence.filter(subject => {
                        const grades = selectedStudentResults.results[subject] || {};
                        return grades.unitTestIObtainMarks || grades.unitTestIIObtainMarks || grades.unitTestIIIObtainMarks || grades.unitTestIVObtainMarks || grades.unitTestVObtainMarks || grades.unitTestVIObtainMarks || grades.firstSemesterObtainMarks || grades.secondSemesterObtainMarks;
                      });
                      const totalMaxMarks = filteredSubjects.reduce((total, subject) => {
                        const grades = selectedStudentResults.results[subject] || {};
                        return total + (grades.unitTestIOutOf || 0) + (grades.unitTestIIOutOf || 0) + (grades.unitTestIIIOutOf || 0) + (grades.unitTestIVOutOf || 0) + (grades.unitTestVOutOf || 0) + (grades.unitTestVIOutOf || 0) + (grades.firstSemesterOutOf || 0) + (grades.secondSemesterOutOf || 0);
                      }, 0);
                      const totalObtainedMarks = filteredSubjects.reduce((total, subject) => {
                        const grades = selectedStudentResults.results[subject] || {};
                        return total + (grades.unitTestIObtainMarks || 0) + (grades.unitTestIIObtainMarks || 0) + (grades.unitTestIIIObtainMarks || 0) + (grades.unitTestIVObtainMarks || 0) + (grades.unitTestVObtainMarks || 0) + (grades.unitTestVIObtainMarks || 0) + (grades.firstSemesterObtainMarks || 0) + (grades.secondSemesterObtainMarks || 0);
                      }, 0);
                      const percentage = totalMaxMarks > 0 ? (totalObtainedMarks / totalMaxMarks) * 100 : 0;
                      return language === 'English' ? calculateGradeEnglish(percentage) : calculateGradeMarathi(percentage);
                    })()}
                  </td>
                </tr>
              )}
              
            
          </tbody>
        </table>
      </div>
    ) : (
      <div style={{
        padding: '20px',
        textAlign: 'center',
        color: '#7f8c8d',
        fontStyle: 'italic'
      }}>
        {language === "English" ? "No results available." : "कोणतेही प्रगतीपत्रक उपलब्ध नाहीत."}
      </div>
    )}

                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <p style={{ margin: 0, marginRight: '10px', fontSize: '14px' }}><b>Attendance :</b></p>
                    <input
                      type="text"
                      id="attendance"
                      placeholder="Enter attendance"
                      value={attendance}
                      onChange={(e) => setAttendance(e.target.value)}
                      style={{
                        border: 'none',
                        borderBottom: '1px solid transparent',
                        outline: 'none',
                        padding: '5px 0',
                        background: 'transparent',
                        width: '100px' // Add this line to set the width
                        , fontSize: '12px'
                      }}
                    />

                    <p style={{ margin: '0 10px', fontSize: '14px' }}><b>Teacher's  Remark : </b></p>
                    <input
                      type="text"
                      id="remark-input"
                      placeholder="Enter Remark"
  value={remarkText}
  onChange={(e) => setRemarkText(e.target.value)}
                      style={{
                        border: 'none',
                        borderBottom: '1px solid transparent',
                        outline: 'none',
                      
                        background: 'transparent',
                       width: '510px',
                           padding: '5px 0',
                        fontSize: '12px'
                      }}
                    />
                  </div>


                  <div
                    className="grad"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "0 20px", height: '50px',
                      position: 'sticky', top: '630px'
                    }}
                  >
                    {/* Left-aligned label and date input */}
                    <div className='parent-area' style={{ textAlign: "left", marginTop: '29px' }}>
                      <label
                        style={{
                          marginBottom: "0px",
                        }}
                        htmlFor="class-teacher"
                      >
                        {language === "English" ? "Parent's Sign" : "पालक"}
                      </label>
                      <div>
                        {language === "English" ? (
                          <div>
                            <label htmlFor="date" style={{ marginRight: "8px" }}>
                              Date:
                            </label>
                            <input
                              type="date"
                              id="date" value={selectedDate}
  onChange={(e) => {
    setSelectedDate(e.target.value);
    setDateSelected(!!e.target.value);
  }}
                              style={{
                                padding: "2px 4px",
                                width: "150px",
                                border: "none",
                                ...(dateSelected && {
                                  appearance: "none",
                                  WebkitAppearance: "none",
                                }),
                              }}
                              className={dateSelected ? "hide-picker" : ""}
                            />
                          </div>
                        ) : (
                          <label htmlFor="parent-sign">दिनांक</label>
                        )}
                      </div>


                    </div>
                    {/* Center-aligned label */}
                    <label
                      style={{
                        flex: 1,
                        textAlign: "center",
                        marginBottom: "2px",
                      }}
                      htmlFor="class-teacher"
                    >
                      {language === "English" ? "Class Teacher Sign" : "वर्गशिक्षक"}
                    </label>

                    {/* Right-aligned label */}
                    <label
                      style={{
                        flex: 1,
                        textAlign: "right",
                        marginBottom: "2px",
                        marginRight: "20px",
                      }}
                      htmlFor="principal"
                    >
                      {language === "English" ? "Principal Sign" : "प्राचार्य"}
                    </label>

                    <style jsx>{`
        .hide-picker::-webkit-calendar-picker-indicator {
          display: none;
        }
      `}</style>
                  </div>


                  <style jsx>{`
  .no-picker::-webkit-calendar-picker-indicator {
    display: none;
    -webkit-appearance: none;
  }
`}</style>





                </div>


                <Button variant="primary" onClick={handlePrit} style={{ float: 'right' }}>
                  {language === "English" ? "Print" : "Print करा"}
                </Button>
              </div>



            )}

          </Modal.Body>
          <Modal.Footer>
          <Button variant="primary" onClick={handleSaveADR} style={{ marginRight: '10px' }}>
    {language === "English" ? "Save Details" : "तपशील जतन करा"}
  </Button>
            <Button variant="secondary" onClick={handleCloseModal}>
              {language === "English" ? " Close " : "Close करा"}
            </Button>
            {selectedExamName !== "Combined Result" && (
              <Button variant="primary" onClick={handlePrint}>
                {language === "English" ? "Print" : "Print करा"}
              </Button>
            )}
          </Modal.Footer>
        </Modal>

      </div>
    </div>
  );
};

export default CbseHighSchoolResult;
